export const desktopBreakpoint = 1010;

/**
 * Medication list
 */

export const medicationList = [
  '0.9% SODIUM CHLORIDE',
  '1% LIDOCAINE HCI',
  '1ST MEDXPATCH',
  '1ST MEDXPATCH WITH LIDOCAINE 4%-RX',
  '2% LIDOCAINE HCI',
  '25% Dextrose Infant',
  '3% Sodium Chloride',
  '40% Oxygen/Nitrogen Mix',
  '5% DEXTROSE',
  '50% DEXTROSE',
  '50% MAGNESIUM SULFATE',
  '6% HETASTARCH IN 0.9% SODIUM CHLORIDE',
  '60 Second Fluoride Gel',
  '7 Standardized Grass Pollen Mix',
  '7.5% SODIUM BICARBONATE',
  '8.4% SODIUM BICARBONATE',
  '9 Southern Grass Pollen Mix',
  'Abacavir',
  'Abacavir and Lamivudine',
  'Abacavir Sulfate',
  'ABACAVIR, LAMIVUDINE AND ZIDOVUDINE',
  'ABELCET',
  'ABILIFY',
  'ABILIFY MAINTENA',
  'Abilify MyCite',
  'Abiraterone',
  'Abiraterone Acetate',
  'ABRAXANE',
  'Absinthium',
  'Absorica',
  'Absorica LD',
  'Abstral',
  'Acamprosate Calcium',
  'Acanya',
  'Acarbose',
  'Acclean Chlorhexidine Gluconate 0.12% Oral Rinse',
  'Acclean Foam Fluoride 60 Second Application',
  'Acclean plus',
  'Accolate',
  'ACCRUFER',
  'Accucaine',
  'Accupril',
  'ACCURETIC',
  'ACCUTANE',
  'ACD',
  'ACD Blood-Pack Units (PL 146 Plastic)',
  'ACD-A',
  'Acebutolol Hydrochloride',
  'ACETADOTE',
  'Acetaminophen and Codeine',
  'Acetaminophen and Codeine Phosphate',
  'Acetaminophen, Caffeine, Dihydrocodeine Bitartrate',
  'AcetaZOLAMIDE',
  'ACETAZOLAMIDE EXTENDED-RELEASE',
  'Acetic Acid',
  'Aceticum acidum',
  'Acetylcysteine',
  'AcipHex',
  'Acitretin',
  'AcNesic Acne Treatment',
  'ACTEMRA',
  'Actemra ACTPen',
  'Acthar',
  'Acthrel',
  'Acticlate',
  'Actidose Aqua',
  'ACTIMMUNE',
  'ACTIQ',
  'Activase',
  'ACTIVATED CHARCOAL',
  'Activella',
  'Actonel',
  'Actoplus Met',
  'Actos',
  'Acular',
  'ACULAR LS',
  'Acunistat-30',
  'Acunistat-60',
  'Acunivive 15',
  'Acunivive 30',
  'Acunivive 60',
  'Acunivive 90',
  'Acunol',
  'ACUVAIL',
  'Acyclovir',
  'Acyclovir Sodium',
  'Acyclovix',
  'ACZONE',
  'ADAKVEO',
  'Adapalene',
  'adapalene and benzoyl peroxide',
  'Adapalene Topical Solution',
  'Adbry',
  'ADCETRIS',
  'ADCIRCA',
  'Adderall',
  'Additive Formula 3',
  'ADDYI',
  'ADEFOVIR DIPIVOXIL',
  'Adempas',
  'Adenocard',
  'Adenosine',
  'Adenosine Injection, 6mg/2mL (3mg/mL) Vial',
  'ADHANSIA XR',
  'Adipex-P',
  'Adlarity',
  'ADLYXIN',
  'ADMELOG',
  'Adrenalin',
  'ADRENALIN (EPINEPHRINE)',
  'ADRENALIN(R)',
  'AdreView',
  'Adriamycin',
  'ADSOL RED CELL PRESERVATION',
  'ADSOL Red Cell Preservation Solution System in Plastic Container (PL 146 Plastic)',
  'Aduhelm',
  'Adult Infuvite Multiple Vitamins',
  'ADVAIR',
  'ADVAIR HFA',
  'Adzenys XR-ODT',
  'Aemcolo',
  'Afinitor',
  'Afirmelle',
  'Afrezza',
  'AGGRASTAT',
  'Agnus castus',
  'Agrylin',
  'Ahealon',
  'AIMOVIG',
  'Air',
  'Air 90% Carbon Dioxide 10%',
  'AIR COMPRESSED',
  'Air, Compressed',
  'AirDuo Digihaler',
  'AirDuo RespiClick',
  'AJOVY',
  'AK-FLUOR',
  'AKLIEF',
  'Akovaz',
  'AK-POLY-BAC',
  'Akten',
  'AKYNZEO',
  'Alacort',
  'Ala-Scalp',
  'Albendazole',
  'ALBENZA',
  'ALBUMINEX',
  'Albuterol',
  'Albuterol Sulate',
  'Albuterol Sulfate',
  'albuterol sulfate HFA',
  'Albuterol Sulfate Inhalation Solution',
  'Alcaine',
  'Alclometasone Dipropionate',
  'ALDACTAZIDE',
  'Aldactone',
  'Aldara',
  'ALDURAZYME',
  'ALECENSA',
  'Alendronate',
  'Alendronate Sodium',
  'Alfentanil',
  'Alfentanil Hydrochloride',
  'Alferon',
  'ALFUZOSIN HYDROCHLORIDE',
  'Alimta',
  'Alinia',
  'ALIQOPA',
  'ALISKIREN',
  'ALKERAN',
  'Alkindi',
  'Allopurinol',
  'Allopurinol sodium',
  'ALLZITAL',
  'almotriptan',
  'Almotriptan Malate',
  'ALOCRIL',
  'Alogliptin',
  'alogliptin and metformin hydrochloride',
  'Alogliptin and Pioglitazone',
  'ALOMIDE',
  'Aloprim',
  'Alora',
  'Alosetron',
  'Alosetron Hydrochloride',
  'Aloxi',
  'ALPHAGAN P',
  'Alpha-Pro',
  'Alprazolam',
  'Alprostadil',
  'ALREX',
  'Altabax',
  'ALTACE',
  'ALTAFLUOR',
  'ALTAVERA',
  'Altoprev',
  'Altreno',
  'Alunbrig',
  'Alvesco',
  'Alvimopan',
  'ALYACEN 1/35',
  'ALYACEN 7/7/7',
  'ALYQ',
  'AMABELZ',
  'amantadine',
  'Amantadine HCl',
  'AMANTADINE HYDROCHLORIDE',
  'AMARYL',
  'Ambien',
  'AmBisome',
  'Ambrisentan',
  'Amcinonide',
  'AMELUZ',
  'AMERGE',
  'Amethia',
  'Amethyst',
  'AMICAR',
  'Amidate',
  'AMIDATE(TM) ETOMIDATE',
  'Amikacin Sulfate',
  'Amiloride Hydrochloride',
  'Amiloride Hydrochloride and Hydrochlorothiazide',
  'Amiloride Hydrochloride',
  'AMINOCAPROIC ACID',
  'Aminophylline',
  'Aminosyn II',
  'Aminosyn-PF',
  'AMIODARONE HCI',
  'Amiodarone HCl',
  'Amiodarone Hydrochloride',
  'Amitiza',
  'Amitriptyline hcl',
  'Amitriptyline Hydrochloride',
  'Amlodipine and atorvastatin',
  'Amlodipine and Benazepril Hydrochloride',
  'Amlodipine and Olmesartan Medoxomil',
  'AMLODIPINE AND VALSARTAN',
  'Amlodipine besylate',
  'Amlodipine besylate and Atorvastatin calcium',
  'Amlodipine Besylate and Benazepril Hydrochloride',
  'Amlodipine besylate and Olmesartan medoxomil',
  'Amlodipine besylate and Olmesartran medoxomil',
  'Amlodipine, Valsartan and Hydrochlorothiazide',
  'AMLODIPINE, VALSARTAN, HYDROCHLOROTHIAZIDE',
  'Ammonia',
  'Ammonia N 13',
  'AMMONIA N-13',
  'Ammonium Lactate',
  'Ammonul',
  'Amnesteem',
  'AMOLDIPINE BENAZEPRIL HCL',
  'AMONDYS 45',
  'Amoxapine',
  'Amoxicillin',
  'Amoxicillin and Clavulanate Potassium',
  'AMOXICILLIN CLAV/POT',
  'AMOXICILLIN/CLAV POT',
  'AMOXIL',
  'AMPHADASE',
  'Amphenol-40',
  'Amphetamine Sulfate',
  'Amphotericin B',
  'AMPICILLIN',
  'Ampicillin and Sulbactam',
  'Ampicillin Sodium',
  'ampicillin sodium and sulbactam sodium',
  'AMPYRA',
  'AMRIX',
  'Amygdalus persica',
  'Amyl Nitrite',
  'Amytal Sodium',
  'Amyvid',
  'AMZEEQ',
  'ANAFRANIL',
  'anagrelide',
  'Anagrelide Hydrochloride',
  'Analpram HC',
  'ANAPROX',
  'Anaprox DS',
  'ANASPAZ',
  'Anastrozole',
  'ANCOBON',
  'ANDEXXA',
  'Androderm',
  'Androgel',
  'Androxy',
  'Anectine',
  'Angeliq',
  'Angiomax',
  'Angiomax RTU',
  'ANIMAL ANTIGEN',
  'Anjeso',
  'ANNALONIUM LEWINII',
  'ANNOVERA',
  'Anoro Ellipta',
  'Antara',
  'Anthim',
  'Anticoagulant Citrate Dextrose A',
  'Anticoagulant Citrate Dextrose A ACD-A',
  'Anticoagulant Citrate Phosphate Dextrose (CPD) Blood-Pack Units in PL 146 Plastic',
  'Anticoagulant Sodium Citrate',
  'Antivert',
  'ANUCORT-HC',
  'Anusol',
  'Anusol HC',
  'ANZEMET',
  'APADAZ',
  'ApexiCon E',
  'Apidra',
  'Apidra SoloStar',
  'apixaban',
  'Aplenzin',
  'Aplisol',
  'APOKYN',
  'apomorphine hydrocloride',
  'APO-VARENICLINE',
  'Apraclonidine',
  'Apraclonidine Ophthalmic',
  'APREMILAST',
  'Aprepitant',
  'Apretude',
  'Apri',
  'APRISO',
  'Aprizio Pak',
  'Aprizio Pak II',
  'APTENSIO XR',
  'Aptiom',
  'Aptivus',
  'AQUASOL A',
  'Aquax-H',
  'Arakoda',
  'Aralia Racemosa MT',
  'Aranelle',
  'ARANESP',
  'Arava',
  'Arazlo',
  'Arcalyst',
  'Arestin',
  'Arformoterol tartrate',
  'Arformoterol Tartrate Inhalation',
  'ARGATROBAN',
  'Aricept',
  'Aridol Bronchial Challenge Test Kit',
  'ARIKAYCE',
  'ARIMIDEX',
  'Aripiprazole',
  'ARISTADA',
  'ARISTADA INITIO',
  'Arixtra',
  'Armodafinil',
  'ArmonAir Digihaler',
  'Armour Thyroid',
  'Arnuity Ellipta',
  'Aromasin',
  'Arranon',
  'Arsenic Trioxide',
  'Artesunate',
  'ARTHROTEC',
  'Articadent',
  'ARTICAINE',
  'Articaine HCl and Epinephrine',
  'Articaine Hydrochloride and Epinephrine',
  'ARZERRA',
  'AS',
  'Asacol HD',
  'ASCENIV',
  'Asclera',
  'Ascomp with Codeine',
  'Ascor',
  'ASENAPINE',
  'Asenapine Maleate',
  'Ashlyna',
  'ASMANEX',
  'ASMANEX HFA',
  'asparlas',
  'Aspirin and Dipyridamole',
  'Aspirin and Extended - Release Dipyridamole Capsules, 25 mg / 200 mg',
  'Aspirin and Extended-Release Dipyridamole',
  'aspirin-dipyridamole',
  'ASPRIN AND EXTENDED-RELEASE DIPYRIDAMOLE',
  'ASPRUZYO SPRINKLE',
  'ASTAGRAF XL',
  'ATACAND',
  'ATACAND HCT',
  'Atazanavir',
  'Atazanavir Sulfate',
  'Atelvia',
  'Atenolol',
  'Atenolol and Chlorthalidone',
  'Ativan',
  'ATNAA atropine and pralidoxime chloride',
  'Atomoxetine',
  'Atomoxetine Hydrochloride',
  'Atorvastatin Calcium',
  'Atovaquone',
  'Atovaquone and Proguanil HCl',
  'Atovaquone and Proguanil Hydrochloride',
  'Atovaquone and Proguanil Hydrochloride Pediatric',
  'Atovaquone Oral Suspension',
  'Atracurium Besylate',
  'Atralin',
  'Atripla',
  'ATROPEN Auto-Injector',
  'Atropine',
  'ATROPINE SULFATE',
  'Atrovent',
  'ATryn',
  'Aubagio',
  'AUBRA',
  'Aubra EQ',
  'Aurovela 1.5/30',
  'Aurovela 1/20',
  'Aurovela 24 Fe',
  'AUROVELA Fe',
  'Aurovela Fe 1/20',
  'Aurum muriaticum kalinatum',
  'Auryxia',
  'Austedo',
  'Auvi-Q',
  'Avalide',
  'Avapro',
  'AVAR',
  'AVAR LS',
  'Avar-e',
  'Avar-e Green',
  'Avar-e LS',
  'Avastin',
  'Aveed',
  'Aviane',
  'Avita',
  'Avoca Flexible Caustic Applicator',
  'AVODART',
  'Avonex',
  'Avonex Pen',
  'AVSOLA',
  'AVYCAZ',
  'Axumin',
  'Aygestin',
  'Ayuna',
  'Ayvakit',
  'Azacitidine',
  'azacitidine for',
  'AZACTAM',
  'Azasan',
  'AzaSITE',
  'Azathioprine',
  'Azathioprine Sodium',
  'Azedra',
  'Azelaic Acid',
  'Azelaic Acid Gel',
  'Azelastine',
  'azelastine hcl nasal',
  'Azelastine Hydrochloride',
  'Azelastine Hydrochloride and Fluticasone Propionate',
  'Azelastine Hydrochloride Ophthalmic Solution 0.05%',
  'AZELEX',
  'Azilect',
  'Azithromycin',
  'Azithromycin Dihydrate',
  'azithromycin monohydrate',
  'Azopt',
  'Azor',
  'AZSTARYS',
  'Aztreonam',
  'Azulfidine',
  'Azurette',
  'BabyBIG',
  'BACILLINUM PULMO',
  'Bacitracin Zinc and Polymyxin B Sulfate',
  'Back and Leg HP',
  'Baclofen',
  'Baclofen (Intrathecal)',
  'Bacteriostatic Sodium Chloride',
  'Bacteriostatic Water',
  'Bactrim',
  'Bactrim DS',
  'BAFIERTAM',
  'BAL',
  'Balanced Salt',
  'Balancer',
  'Balcoltra',
  'Balsalazide Disodium',
  'BALVERSA',
  'Balziva',
  'Bamlanivimab',
  'Banzel',
  'Baqsimi',
  'BARACLUDE',
  'Barhemsys',
  'Baricitinib',
  'BASAGLAR',
  'BAVENCIO',
  'Baxdela',
  'Bebtelovimab',
  'BECONASE',
  'Bekyree',
  'BELBUCA',
  'Beleodaq',
  'Belladonna and Opium',
  'BELRAPZO',
  'BELSOMRA',
  'Belviq',
  'BELVIQ XR',
  'Benazepril',
  'Benazepril Hydrochloride',
  'Benazepril Hydrochloride and Hydrochlorothiazide',
  'Bendeka',
  'Benicar',
  'Benicar HCT',
  'BENLYSTA',
  'Bensal HP',
  'Bentyl',
  'Benzaclin',
  'Benzamycin',
  'BenzePrO',
  'Benzhydrocodone and Acetaminophen',
  'Benznidazole',
  'benzonatate',
  'BENZPHETAMINE HYDROCHLORIDE',
  'Benztropine Mesylate',
  'BEOVU',
  'Bepotastine Besilate',
  'Bepreve',
  'Bermuda Grass, Standardized',
  'Besivance',
  'Besponsa',
  'BESREMi',
  'Beta 1 Kit',
  'Betadine',
  'BETAGAN',
  'Betaine Anhydrous For Oral Solution',
  'Betalido Kit',
  'Betaloan SUIK',
  'Betamethasone Dipropionate',
  'Betamethasone Dipropionate USP, 0.05%',
  'Betamethasone Sodium Phosphate and Betamethasone Acetate',
  'Betamethasone Valerate',
  'Betapace',
  'Betapace AF',
  'BETASEPT',
  'Betaseron',
  'Betaxolol',
  'BETAXOLOL HYDROCHLORIDE',
  'Bethanechol Chloride',
  'BETHKIS',
  'Betimol',
  'Betoptic S',
  'BEVESPI AEROSPHERE',
  'Bexarotene',
  'Beyaz',
  'BHI Uri-Control RX',
  'Bicalutamide',
  'BICILLIN CR',
  'BICILLIN C-R 900/300',
  'BICILLIN L-A',
  'BiCNU',
  'BiDil',
  'Bijuva',
  'Biktarvy',
  'Biltricide',
  'Bimatoprost',
  'Binosto',
  'Bio Psorinum Phase',
  'BioGlo',
  'Biorphen',
  'Bisoprolol',
  'Bisoprolol Fumarate',
  'bisoprolol fumarate and hydrochlorothiazide',
  'Bivalirudin',
  'Bivalirudin in 0.9% Sodium Chloride',
  'BIVIGAM',
  'Blenrep',
  'Bleomycin',
  'BLEPH-10',
  'BLEPHAMIDE',
  'BLINCYTO',
  'Blisovi 24 Fe',
  'BLISOVI FE 1.5/30',
  'Blisovi Fe 1/20',
  'Bloxiverz',
  'Boniva',
  'BONJESTA',
  'Bortezomib',
  'Bosentan',
  'BOSULIF',
  'BOTOX',
  'BOTOX Cosmetic',
  'BP Cleansing Wash',
  'BRAFTOVI',
  'Breo Ellipta',
  'Brevibloc',
  'Brevital Sodium',
  'BREXAFEMME',
  'BREYNA',
  'BREZTRI',
  'BRIDION',
  'BRIELLYN',
  'BRILINTA',
  'Brimonidine',
  'Brimonidine Tartrate',
  'Brimonidine Tartrate and Timolol Maleate',
  'Brimonidine Tartrate/Timolol Maleate',
  'Brineura',
  'Brinzolamide',
  'BRISDELLE',
  'Briviact',
  'Bromfed DM',
  'bromfenac',
  'Bromfenac Ophthalmic Solution 0.09%',
  'Bromocriptine Mesylate',
  'Brompheniramine Maleate, Pseudoephedrine Hydrochloride and Dextromethorphan Hydrobromide',
  'Brompheniramine Maleate, Pseudoephedrine Hydrochloride and DextromethorphanHydrobromide',
  'Brompheniramine maleate, pseudoephedrine hydrochloride,',
  'Brompheniramine Maleate, Pseudoephedrine Hydrochloride, and Dextromethorphan Hydrobromide',
  'Brompheniramine Maleate, Pseudoephedrine Hydrochloride, Dextromethorphan Hydrobromide',
  'Brompheniramine, Pseudoephedrine, Dextromethorphan',
  'BROMSITE',
  'Bronchitol',
  'Brovana',
  'BRUKINSA',
  'Bryhali',
  'BSP 0820',
  'BSS',
  'BSS PLUS',
  'Buckleys Formo Cresol',
  'Budesonide',
  'BUDESONIDE (ENTERIC COATED)',
  'Budesonide and Formoterol Fumarate Dihydrate',
  'Budesonide Inhalation',
  'Budesonide Inhalation Suspension',
  'Budesonide Nasal',
  'BUFFERED PENICILLIN G POTASSIUM',
  'Bufo rana',
  'Bumetanide',
  'Bumex',
  'BUPAP',
  'BUPHENYL',
  'Bupivacaine',
  'BUPIVACAINE HCI AND EPINEPHRINE',
  'Bupivacaine Hydrochloride',
  'Bupivacaine Hydrochloride and Epinephrine',
  'Bupivacaine Hydrochloride with Dextrose',
  'BUPIVICAINE HYDROCHLORIDE',
  'Bupivilog Kit',
  'Buprenex',
  'Buprenorphene',
  'Buprenorphine',
  'Buprenorphine and Naloxone',
  'Buprenorphine HCl',
  'Buprenorphine HCl and Naloxone HCl',
  'Buprenorphine Hydrochloride',
  'buprenorphine hydrochloride and naloxone hydrochloride dihydrate',
  'bupropion',
  'BUPROPION HCL ER',
  'Bupropion Hydrochloride',
  'BUPROPION HYDROCHLORIDE (SR)',
  'Bupropion hydrochloride (XL)',
  'Bupropion Hydrochloride Extended Release',
  'Burapren 0.5%',
  'Burapren 0.75%',
  'Burkhart',
  'Burkhart Neutral pH',
  'busPIRone HCl',
  'Buspirone Hydrochloride',
  'BUSULFAN',
  'BUSULFEX',
  'Butalbita,Acetaminophen and Caffeine',
  'butalbital and acetaminophen',
  'butalbital, acetaminophen and caffeine',
  'Butalbital, Acetaminophen, and Caffeine',
  'Butalbital, Acetaminophen, Caffeine',
  'Butalbital, Acetaminophen, Caffeine and Codeine Phosphate',
  'Butalbital, Acetaminophen, Caffeine, and Codeine Phosphate',
  'Butalbital, Aspirin and Caffeine',
  'Butalbital, aspirin, and caffeine',
  'Butalbital, Aspirin, Caffeine and Codeine Phosphate',
  'Butalbital, Aspirin, Caffeine, and Codeine Phosphate',
  'Butorphanol Tartrate',
  'Butrans',
  'BYDUREON',
  'BYDUREON BCise',
  'Byetta',
  'BYFAVO',
  'BYLVAY',
  'Bystolic',
  'Cabenuva',
  'Cabergoline',
  'Cablivi',
  'CABOMETYX',
  'CACTUS',
  'Cadira Compliant Blood Stat',
  'Caduet',
  'CAFCIT',
  'Cafergot',
  'Caffeine and Sodium Benzoate',
  'Caffeine Citrate',
  'Caffeine Citrate Oral Solution',
  'CALAN SR',
  'Calcipotriene',
  'Calcipotriene 0.005% 60 gram Foam',
  'CALCIPOTRIENE AND BETAMETHASONE DIPROPIONATE',
  'Calcitonin Salmon',
  'Calcitrene',
  'Calcitriol',
  'Calcium Acetate',
  'Calcium Chloride',
  'Calcium Disodium Versenate',
  'Calcium Folic Acid Plus D Chewable',
  'Calcium Gluconate',
  'Caldolor',
  'CALQUENCE',
  'Cambia',
  'CAMCEVI',
  'CAMILA',
  'Campath',
  'Camptosar',
  'Camrese',
  'camrese Lo',
  'Canasa',
  'CANCIDAS',
  'Candesartan',
  'candesartan cilexetil',
  'Candesartan Cilexetil and Hydrochlorothiazide',
  'Candin',
  'CAPASTAT SULFATE',
  'Capecitabine',
  'Capecitabine 150mg',
  'Capecitabine 500mg',
  'Capex',
  'CAPLYTA',
  'CAPRELSA',
  'Captopril',
  'Carac',
  'Carafate',
  'Carbaglu',
  'Carbamazepin',
  'Carbamazepine',
  'Carbatrol',
  'Carbidopa',
  'Carbidopa and levodopa',
  'Carbidopa Tablets, 25 mg',
  'Carbidopa, Levodopa and Entacapone',
  'Carbidopa, Levodopa, and Entacapone',
  'Carbinoxamine Maleate',
  'Carbocaine',
  'Carbocaine with Neo-Cobefrin',
  'Carbogen',
  'Carbon Dioxide',
  'Carbon Dioxide Air',
  'Carbon Dioxide Air Mixture',
  'CARBON DIOXIDE AND OXYGEN MIXTURE, COMPRESSED, OXIDIZING, N.O.S.',
  'Carbon Dioxide Nitrogen',
  'Carbon Dioxide Oxygen',
  'Carbon Dioxide Oxygen Mix',
  'Carbon Dioxide Oxygen Mixture',
  'Carbon Dioxide Oxygen Mixture 5/95',
  'Carbon Dioxide Refrigerated',
  'Carbon Dioxide/Oxygen 5/95',
  'Carbon Dioxide/Oxygen Mix',
  'Carbon Dioxide-Air Mixture',
  'Carbon Dioxide-Oxygen Mixture',
  'Carboplatin',
  'Carboprost Tromethamine',
  'Cardene IV',
  'CardioGen-82',
  'Cardiolite',
  'Cardioplegic',
  'Cardizem',
  'Cardizem CD',
  'Cardizem LA',
  'Cardura',
  'Carglumic Acid',
  'Carisoprodol',
  'CARISOPRODOL, ASPIRIN AND CODEINE PHOSPHATE',
  'CARMUSTINE',
  'CARNEXIV',
  'CARNITOR',
  'Carnitor SF',
  'CaroSpir',
  'Carteolol Hydrochloride',
  'Cartia',
  'CARTIA XT',
  'Carvedilol',
  'Carvedilol Phosphate',
  'Casirivimab',
  'casirivimab with imdevimab',
  'CASODEX',
  'CASPOFUNGIN ACETATE',
  'CASPORYN HC',
  'Cat Hair, Standardized',
  'Cat Pelt, Standardized',
  'CATAFLAM',
  'Catapres-TTS',
  'Catapres-TTS-1',
  'Catapres-TTS-2',
  'Catapres-TTS-3',
  'Cathflo Activase',
  'Caverject',
  'Caverject Impulse',
  'Cayston',
  'Caziant',
  'Ceanothus americanus',
  'Cefaclor',
  'Cefadroxil',
  'Cefazolin',
  'Cefazolin Sodium',
  'Cefdinir',
  'Cefepime',
  'CEFEPIME HYDROCHLORIDE',
  'CEFEPIME HYDROCHLORIDE AND DEXTROSE',
  'Cefixime',
  'Cefotaxime',
  'Cefotetan',
  'Cefotetan and Dextrose',
  'Cefoxitin',
  'Cefoxitin and Dextrose',
  'Cefpodoxime Proxetil',
  'Cefprozil',
  'Ceftazidime',
  'Ceftazidime and Dextrose',
  'Ceftriaxone',
  'CEFTRIAXONE AND DEXTROSE',
  'Ceftriaxone Sodium',
  'Cefuroxime',
  'Cefuroxime and Dextrose',
  'Cefuroxime Axetil',
  'Cefuroxime sodium',
  'CELEBREX',
  'Celecoxib',
  'Celecoxib 200 mg',
  'CELESTONE SOLUSPAN',
  'Celexa',
  'CellCept',
  'Celontin',
  'CENTANY',
  'Centratex',
  'Cephalexin',
  'CEPHALEXIN ORAL SUSP',
  'CEQUA',
  'Cerdelga',
  'CEREBYX',
  'CERETEC',
  'Cerezyme',
  'CERIANNA',
  'Certa Dose Epinephrine Convenience Kit',
  'CERVIDIL',
  'Cesamet',
  'Cetacaine Anesthetic',
  'Cetacaine Topical Anesthetic',
  'Cetirizine Hydrochloride Oral Solution',
  'CETRAXAL',
  'Cetrotide',
  'Cevimeline',
  'Cevimeline Hydrochloride',
  'CHANTIX',
  'Charlotte 24Fe',
  'CHATEAL',
  'Chateal EQ',
  'Chavita 7',
  'Chemet',
  'Chenodal',
  'Chimaphila umbellata',
  'ChiRhoStim',
  'ChiRhoStim 40',
  'Chloramphenicol Sodium Succinate',
  'CHLORDIAZEPOXIDE',
  'Chlordiazepoxide and Amitriptyline Hydrochloride',
  'Chlordiazepoxide Hydrochloride',
  'Chlordiazepoxide Hydrochloride and Clidinium Bromide',
  'Chlordiazepoxide Hydrochloride/Clidinium Bromide',
  'Chlorhexidine',
  'Chlorhexidine Gluconante',
  'Chlorhexidine Gluconate',
  'Chlorhexidine Gluconate 0.12% Oral Rinse',
  'Chlorhexidine Gluconate, 0.12% Oral Rinse Solution',
  'Chloromag',
  'CHLOROPROCAINE HCI',
  'CHLOROPROCAINE HCI',
  'Chloroprocaine Hydrochloride',
  'Chloroquine Phosphate',
  'Chlorothiazide',
  'Chlorothiazide Sodium',
  'CHLORPROMAZINE HCI',
  'CHLORPROMAZINE HYDROCHLORIDE',
  'Chlorthalidone',
  'Chlorzoxazone',
  'Cholbam',
  'Cholesterinum',
  'Cholestyramine',
  'cholestyramine light',
  'cholestyramine powder for suspension',
  'Choletec',
  'Choleystyramine Light',
  'Choline C 11',
  'CHOLINE MAGNESIUM TRISALICYLATE',
  'Chorionic Gonadotropin',
  'Chromagen',
  'Chromium',
  'CHROMIUM CHROMIC CHLORIDE',
  'Cialis',
  'Cibinqo',
  'Ciclodan',
  'Ciclopirox',
  'Ciclopirox Olamine',
  'CIDOFOVIR',
  'CIDOFOVIR DIHYDRATE',
  'Cilostazol',
  'Ciloxan',
  'CIMDUO',
  'Cimetidine',
  'CIMETIDINE HYDROCHLORIDE',
  'Cimetidine Hydrochloride Oral Solution',
  'Cimzia',
  'Cinacalcet',
  'Cinacalcet Hydrochloride',
  'CINQAIR',
  'CINVANTI',
  'CIPRO',
  'CIPRODEX',
  'Ciprofloxacin',
  'Ciprofloxacin and Dexamethasone',
  'Ciprofloxacin and Fluocinolone Acetonide',
  'Ciprofloxacin HCL',
  'Ciprofloxacin HCl Ophthalmic',
  'Ciprofloxacin Hydrochloride',
  'Ciprofloxacin Otic',
  'Cisatracurium',
  'Cisatracurium Besylate',
  'CISplatin',
  'Citalopram',
  'Citalopram Hydrobromide',
  'Citanest Forte DENTAL',
  'Citanest Plain',
  'CitraNatal 90 DHA',
  'CitraNatal Assure',
  'CITRANATAL B-CALM',
  'CitraNatal Bloom',
  'CitraNatal Harmony 3.0',
  'CitraNatal Medley',
  'Citric Buffered Normal Saline',
  'Cladribine',
  'Claravis',
  'Clarinex',
  'CLARINEX-D 12 HOUR',
  'CLARISCAN',
  'Clarithromycin',
  'Clemastine Fumarate',
  'Clematis erecta',
  'Clenia Plus',
  'CLENPIQ',
  'Cleocin',
  'Cleocin Hydrochloride',
  'Cleocin Pediatric',
  'Cleocin Phosphate',
  'Cleocin T',
  'Cleviprex',
  'Climara',
  'Climara Pro',
  'Clindacin ETZ',
  'Clindacin P',
  'Clindacin PAC',
  'Clindagel',
  'Clindamycin',
  'Clindamycin and Benzoyl Peroxide',
  'Clindamycin HCL',
  'Clindamycin Hydrochloride',
  'Clindamycin in 5 Percent Dextrose',
  'Clindamycin Palmitate Hydrochloride',
  'Clindamycin Palmitate Hydrochloride (Pediatric)',
  'Clindamycin Phosphate Topical Solution USP, 1%',
  'Clindamycin Phosphate Topical Solution, 1%',
  'clindamycin phosphate',
  'Clindamycin Phosphate 1.2% and Tretinoin 0.025%',
  'Clindamycin Phosphate and Benzoyl Peroxide',
  'Clindamycin Phosphate and Tretinion',
  'Clindamycin Phosphate and Tretinoin',
  'Clindavix',
  'Clindesse',
  'CLINIMIX',
  'CLINIMIX E',
  'Clinisol',
  'Clinolipid',
  'Clinpro 5000',
  'Clobazam',
  'Clobetasol Propionate',
  'Clobetasol Propionate (Emmolient)',
  'Clobetasol Propionate (emollient)',
  'Clobetasol Propionate Cream',
  'Clobetasol Propionate Cream USP, 0.05%',
  'Clobetavix',
  'Clobetex',
  'Clobex',
  'clocortolone pivalate',
  'Clocortolone Pivalate Cream',
  'Clodan',
  'Clodan Kit',
  'Cloderm',
  'Clofarabine',
  'Clofenax',
  'Clolar',
  'Clomiphene Citrate',
  'Clomipramine HCl',
  'Clomipramine Hydrochloride',
  'Clonazepam',
  'Clonidine',
  'CLONIDINE HCI',
  'Clonidine Hydrochloride',
  'Clonidine transdermal system',
  'Clopidogrel',
  'Clopidogrel Bisulfate',
  'Clorazepate Dipotassium',
  'Clorotekal',
  'Clotrimazole',
  'Clotrimazole and Betamethasone Dipropionate',
  'Clotrimazole Topical Solution USP, 1%',
  'Clozapine',
  'Clozaril',
  'C-Nate DHA',
  'CNJ-016',
  'Coagadex',
  'COARTEM',
  'cocaine hydrochloride',
  'cocaine hydrochloride nasal',
  'Codeine sulfate',
  'Colazal',
  'Colchicine',
  'COLCIGEL',
  'Colcrys',
  'Colesevelam',
  'Colesevelam HCL',
  'Colesevelam Hydrochloride',
  'Colestid',
  'COLESTIPOL HYDROCHLORIDE',
  'Colibacillinum',
  'Colistimethate',
  'Colistimethate Sodium',
  'COLLAGENASE SANTYL',
  'Coly-Mycin',
  'COMBIGAN',
  'CombiPatch (estradiol/norethindrone acetate transdermal system)',
  'Combivent Respimat',
  'COMBIVIR',
  'COMETRIQ',
  'ComPare2 Black Elderberry Cold and Flu Relief',
  'COMPLERA',
  'COMPRESSED Gas OXIDIZING, N.O.S.',
  'COMPRESSED Gas, N.O.S.',
  'Compressed Oxygen',
  'COMPRESSED, N.O.S.',
  'Compro',
  'Comtan',
  'CONCERTA',
  'Condylox',
  'Conjupri',
  'Conray',
  'Consensi',
  'Constulose',
  'Contrave',
  'ConZip',
  'Copaxone',
  'Copiktra',
  'COPPER',
  'Cordran',
  'COREG',
  'Corgard',
  'Corlanor',
  'Corlopam',
  'Corphedra',
  'Cortaren Corticosteroid/Anti-Inflammatory System',
  'CORTEF',
  'Cortenema',
  'Cortifoam',
  'Corti-Sav',
  'Cortisone Acetate',
  'Cortisporin TC',
  'Cortrosyn',
  'Corvatrol 0.9%',
  'Corvert',
  'Cosela',
  'COSENTYX',
  'Cosmegen',
  'COSOPT',
  'COSOPT PF',
  'Cosyntropin',
  'Cotellic',
  'Cotempla XR-ODT',
  'COUMADIN',
  'COZAAR',
  'CPD',
  'CPD/ADSOL',
  'CPDA-1',
  'CPDA-1 Blood Collection System',
  'Crataegus oxyacantha',
  'Creon',
  'CRESEMBA',
  'CRESTOR',
  'Crinone',
  'CRIXIVAN',
  'Cromolyn Sodium',
  'Cromolyn Sodium Oral Solution (Concentrate)',
  'Crotalus cascavella',
  'Crotalus horridus',
  'Crotan',
  'Cryselle',
  'CRYSVITA',
  'Cubicin',
  'CUBICIN RF',
  'Cuprimine',
  'Curosurf',
  'Cutivate',
  'Cuvposa',
  'Cyanocobalamin',
  'cyanocobalamine',
  'Cyanokit',
  'Cyclafem 1/35',
  'Cyclafem 7/7/7',
  'Cyclobenzaprine',
  'CYCLOBENZAPRINE HCI',
  'Cyclobenzaprine HCL',
  'Cyclobenzaprine Hydrochloride',
  'CYCLOBENZPRINE HCL',
  'Cyclogyl',
  'Cyclomydril',
  'Cyclopak',
  'Cyclopentolate',
  'Cyclopentolate Hydrochloride',
  'Cyclophosphamide',
  'CYCLOSERINE',
  'CYCLOSET',
  'Cyclosporine',
  'CycloSPORINE, Modfied',
  'Cyklokapron',
  'Cymbalta',
  'Cyonanz',
  'Cyproheptadine Hydrochloride',
  'CYRAMZA',
  'Cyred EQ',
  'Cystadane',
  'CYSTADROPS',
  'Cystagon',
  'CYSTARAN',
  'Cysto-Conray II',
  'Cystografin',
  'Cystografin Dilute',
  'Cysview',
  'Cytalux',
  'CYTARABINE',
  'Cytomel',
  'Cytotec',
  'Cytovene',
  'D.H.E. 45',
  'Dabigatran Etexilate',
  'Dacarbazine',
  'Dacogen',
  'dactinomycin',
  'Dalfampridine',
  'Daliresp',
  'DALVANCE',
  'Danazol',
  'Dantrium',
  'Dantrolene',
  'Dantrolene Sodium',
  'DANYELZA',
  'DAPIPRAZOLE',
  'DAPSONE',
  'Daptomycin',
  'DAPZURA RT',
  'Daraprim',
  'DARBY APF BUBBLE GUM',
  'DARBY APF MINT',
  'DARBY APF STRAWBERRY',
  'Darifenacin',
  'Darifenacin 15 mg',
  'Darifenacin 7.5 mg',
  'DARTISLA ODT',
  'DARZALEX',
  'Darzalex Faspro',
  'Darzalex IV',
  'Dasetta 1/35',
  'Dasetta 7/7/7',
  'DASH Chlorhexidine Gluconate 0.12% Oral Rinse',
  'DaTscan',
  'Daunorubicin Hydrochloride',
  'Daurismo',
  'Day and Night Vitals',
  'Daypro',
  'Daysee',
  'Daytrana',
  'DAYVIGO',
  'DDAVP',
  'DEBACTEROL Canker Sore Pain Relief',
  'DEBLITANE',
  'Decitabine',
  'Deferasirox',
  'Deferasirox oral',
  'Deferasirox Oral Granules',
  'Deferasorox',
  'Deferiprone',
  'Deferoxamine',
  'Deferoxamine Mesylate',
  'Definity',
  'DEFINITY RT',
  'DEFITELIO',
  'Dehydrated Alcohol',
  'Delestrogen',
  'DELFLEX',
  'DELSTRIGO',
  'Deltasone',
  'Delzicol',
  'Demeclocycline Hydrochloride',
  'DEMEROL',
  'Demser',
  'Denavir',
  'Denta 5000 Plus',
  'DentaGel',
  'Denti-Care Denti-Foam',
  'DentiCare Denti-Pro',
  'Denti-Care Denti-Pro',
  'Denti-Care Denti-Rinse',
  'DentiCare Pro-Gel',
  'Depakote',
  'Depen',
  'Depo-Estradiol',
  'Depo-Medrol',
  'Depo-Provera',
  'Depo-SubQ Provera',
  'Depo-Testosterone',
  'DermacinRx Clorhexacin',
  'DermacinRx Empricaine II',
  'DermacinRx Lexitral PharmaPak',
  'DermacinRx Lexitral PharmaPak II',
  'DermacinRx Lido V Pak',
  'DermacinRx Lidotral',
  'DermacinRx PHN Pak',
  'DermacinRx Purefoltin',
  'DermacinRx Surgical ComboPak',
  'DermacinRx Therazole Pak',
  'DermacinRx ZRM Pak',
  'Dermalid',
  'Derma-Smoothe/FS',
  'DermOtic',
  'DESCOVY',
  'Desferal',
  'Desflurane',
  'Desipramine Hydrochloride',
  'Desloratadine',
  'Desmopressin Acetate',
  'Desogestrel and Ethinyl Estradiol',
  'DESOGESTREL AND ETHINYL ESTRADIOL AND ETHINYL ESTRADIOL',
  'DESONATE',
  'Desonide',
  'Desonide Ointment, 0.05%',
  'DesOwen',
  'Desoximetasone',
  'Desoximetasone Oint 0.05%',
  'Desoxyn',
  'DESRX',
  'Desvenlafaxine',
  'DESVENLAFAXINE ER',
  'Desvenlafaxine Succinate',
  'Detectnet',
  'Detrol',
  'Detrol LA',
  'Dexamethasone',
  'DEXAMETHASONE 6-Day',
  'Dexamethasone Intensol',
  'Dexamethasone Sodium Phosphate',
  'DEXEDRINE',
  'Dexilant',
  'Dexlansoprazole',
  'Dexlido Kit',
  'Dexlido-M Kit',
  'Dexmedetomidine',
  'Dexmedetomidine HCl',
  'Dexmedetomidine Hydrochloride',
  'DEXMEDETOMIDINE HYDROCHLORIDE IN 0.9% SODIUM CHLORIDE',
  'Dexmedetomidine Hydrochloride in Sodium Chloride',
  'Dexmethylphenidate Hydrochloride',
  'Dexrazoxane',
  'Dexrazoxane Hydrochloride',
  'DEXTENZA',
  'Dextroamphetamine',
  'Dextroamphetamine Saccharate and Amphetamine Aspartate and Dextroamphetamine Sulfate and Amphetamine Sulfate',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate Monohydrate, Dextroamphetamine Sulfate and Amphetamine Sulfate',
  'Dextroamphetamine saccharate, amphetamine aspartate monohydrate, dextroamphetamine sulfate, amphetamine sulfate',
  'Dextroamphetamine saccharate, amphetamine aspartate monohydrate, dextroamphetamine sulfate, amphetamine sulfate ER',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate Monohydrate, Dextroamphetamine Sulfate, Amphetamine Sulfate Extended-Release',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate Monohydrate, Dextroamphetamine Sulfate, and Amphetamine Sulfate',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate Monohydrate, Dextroamphetamine Sulfate, and Amphetamine Sulfate Extended-Release',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate, Dextroamphetamine Sulfate and Amphetamine Sulfate',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate, Dextroamphetamine Sulfate, Amphetamine Sulfate Tablets,CII',
  'Dextroamphetamine Saccharate, Amphetamine Aspartate, Dextroamphetamine Sulfate, and Amphetamine Sulfate',
  'Dextroamphetamine Sulfate',
  'Dextroamphetamine SulfateExtended-Release',
  'Dextrose',
  'Dextrose and Electrolyte No. 48',
  'Dextrose And Sodium Chloride',
  'Dextrose in Lactated Ringers',
  'DEXTROSE MONOHYDRATE',
  'Dexycu',
  'DFS 1.5%/MS 25%/MENTH 6%/CAP 0.025% PAK',
  'DFS 75mg DR/MS 25%/MENTH 6%/CAP 0.025% PAK',
  'Dhivy',
  'Diacomit',
  'Dialyvite',
  'Dialyvite 3000',
  'Dialyvite 5000',
  'Dialyvite Supreme D',
  'Dialyvite with Zinc',
  'DIANEAL Low Calcium with Dextrose',
  'DIANEAL PD-2 with Dextrose',
  'Diascreen 12-Panel Medicated Collection System',
  'Diastat',
  'Diazepam',
  'Diazepam Intensol',
  'Diazoxide',
  'Dibasic Sodium Phosphate, Monobasic Potassium Phosphate and Monobasic Sodium Phosphate',
  'Dibenzyline',
  'DICLEGIS',
  'Diclofenac',
  'diclofenac epolamine',
  'Diclofenac Potassium',
  'Diclofenac Sodium',
  'Diclofenac Sodium 1.5%',
  'Diclofenac Sodium and Misoprostol',
  'Diclofenac Sodium D/R',
  'Diclofenac Sodium Delayed Release',
  'Diclofenac Sodium Misoprostol',
  'Diclofenac Sodium Topical Solution',
  'Diclofenac Sodium/Misoprostol',
  'DicloHeal-60',
  'Diclotrex',
  'Diclovix',
  'Diclovix CM',
  'Diclovix M',
  'Dicloxacillin Sodium',
  'Dicyclomine',
  'Dicyclomine HCl',
  'Dicyclomine Hydrochloride',
  'Diethylpropion Hydrochloride',
  'DIETHYLPROPION HYDROCHLORIDE ER',
  'Dificid',
  'Diflorasone Diacetate',
  'Diflorasone Diacetate Oint',
  'Diflucan',
  'Diflunisal',
  'DIFLUPREDNATE',
  'Difluprednate Ophthalmic',
  'Digitalis purpurea',
  'DIGITEK',
  'DIGOX',
  'Digoxin',
  'Dihydroergotamine Mesylate',
  'Dihydroergotamine Mesylate Nasal',
  'Dilantin',
  'Dilantin Infatabs',
  'Dilantin-125',
  'Dilaudid',
  'DILTIAZEM HCI',
  'Diltiazem HCl CD',
  'Diltiazem Hydrochloride',
  'DILTIAZEM HYDROCHLORIDE EXTENDED RELEASE',
  'Diluent',
  'dimethyl fumarate',
  'Diovan',
  'Diovan HCT',
  'Dipentum',
  'DIPHENHYDRAMINE',
  'DIPHENHYDRAMINE HCI',
  'DIPHENHYDRAMINE HYDROCHLORIDE',
  'Diphenoxylate Hydrochloride and Atropine Sulfate',
  'DIPHTHERINUM',
  'Diprivan',
  'DIPROLENE',
  'Dipyridamole',
  'DISKETS',
  'Disopyramide Phosphate',
  'Disulfiram',
  'Ditropan',
  'DIURIL',
  'Divalproex Sodium',
  'DIVIGEL',
  'DMT SUIK',
  'DOBUTAMINE',
  'DOBUTAMINE HYDROCHLORIDE',
  'Dobutamine Hydrochloride in Dextrose',
  'Dobutamine in Dextrose',
  'Docetaxel',
  'Docetaxel anhydrous',
  'DOCTORS CHOICE',
  'DODEX INJECTABLE',
  'Dofetilide',
  'DOJOLVI',
  'Dolishale',
  'DOLOPHINE',
  'Donepezil',
  'Donepezil Hydrochloride',
  'Donepezil Hyrochloride',
  'Donnatal',
  'DOPAMINE HCI',
  'DOPAMINE HCI IN 5% DEXTROSE',
  'Dopamine Hydrochloride',
  'Dopamine Hydrochloride and Dextrose',
  'Dopamine Hydrochloride in Dextrose',
  'Dopram',
  'DOPTELET',
  'DORAL',
  'Doryx',
  'DORYX MPC',
  'Dorzolamide and Timolol',
  'Dorzolamide HCl',
  'Dorzolamide HCl and Timolol Maleate',
  'Dorzolamide Hydrochloride',
  'Dorzolamide Hydrochloride and Timolol Maleate',
  'Dorzolamide Hydrochloride and Timolol Maleate ophthalmic Solution',
  'Dorzolamide Hydrochloride and Timolol Maleate Preservative Free',
  'Dorzolamide Hydrochloride Ophthalmic Solution',
  'DORZOLAMIDE HYDROCHLORIDE TIMOLOL MALEATE',
  'DORZOLAMIDE HYDROCHLORIDE TIMOLOL MALETAE',
  'Dorzolamide Hydrochloride-Timolol Maleate',
  'DOTAREM',
  'Dotremin',
  'DOTTI',
  'DoubleDex Kit',
  'Dovato',
  'Dovonex',
  'DOXAPRAM HYDROCHLORIDE',
  'Doxazosin',
  'Doxazosin Mesylate',
  'Doxepin',
  'DOXEPIN HCL',
  'Doxepin Hydrochloride',
  'DOXERCALCIFEROL',
  'DOXIL',
  'Doxorubicin Hydrochloride',
  'Doxorubicin Hydrochloride Liposome',
  'Doxy 100',
  'DOXY 100(TM) DOXYCYCLINE',
  'Doxycyclate Hyclate',
  'Doxycycline',
  'Doxycycline Hyclate',
  'Doxycycline Monohydrate',
  'Doxylamine Succinate and Pyridoxine Hydrochloride',
  'Drax Exametazime',
  'DRAXIMAGE DTPA',
  'DRAXIMAGE MAA',
  'DRISDOL',
  'DRITHO-CREME',
  'DRIZALMA SPRINKLE',
  'Dromelate',
  'Dronabinol',
  'Droperidol',
  'DROSPIRENONE AND ETHINYL ESTRADIOL',
  'DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM AND LEVOMEFOLATE CALCIUM',
  'Drospirenone/Ethinyl Estradiol/Levomefolate Calcium and Levomefolate Calcium',
  'DROXIA',
  'Droxidopa',
  'Dry Eye Test',
  'Dry Socket',
  'Dsuvia',
  'DUAKLIR PRESSAIR',
  'Duavee',
  'Duet DHA',
  'Duet DHA Balanced',
  'Duetact',
  'DUEXIS',
  'Dulera',
  'Duloxetine',
  'Duloxetine HCL',
  'Duloxetine hydrochloride',
  'Duobrii',
  'DuoDote',
  'Duopa',
  'Dupixent',
  'Duraclon',
  'DURAGESIC',
  'Duramorph',
  'Durapren 0.5%',
  'Durapren 0.75%',
  'DUREZOL',
  'DURYSTA',
  'Dutasteride',
  'Dutasteride and Tamsulosin Hydrochloride',
  'Dutoprol',
  'DX1 OraGenomic Medicated DNA Collection Screen',
  'DX2 OraGenomic Medicated DNA Collection Screen',
  'Dyanavel XR',
  'DycloPro',
  'DYMISTA',
  'Dyrenium',
  'Dysport',
  'Dyural 40 Kit',
  'Dyural 80 Kit',
  'Dyural 80-LM',
  'Dyural L Kit',
  'Dyural LM Kit',
  'E.E.S',
  'EBANGA',
  'EC-Naprosyn',
  'EC-NAPROXEN',
  'Econavix',
  'Econazole Nitrate',
  'ECOZA',
  'Eczemol',
  'Edarbi',
  'Edarbyclor',
  'EDECRIN',
  'Edex',
  'Edluar',
  'ED-SPAZ',
  'EDURANT',
  'Efavirenz',
  'Efavirenz, Emtricitabine and Tenofovir Disoproxil Fumarate',
  'Efavirenz, Lamivudine and Tenofovir Disoproxil Fumarate',
  'Effer-K',
  'Effexor',
  'Effient',
  'Efudex',
  'EGATEN',
  'EGRIFTA SV',
  'Eha',
  'ELAPRASE',
  'ELCYS',
  'ELELYSO',
  'Elemar Patch',
  'Elepsia XR',
  'ELEPSIA XR 1000 MG',
  'ELEPSIA XR 1500 MG',
  'ELESTRIN',
  'Eletriptan',
  'Eletriptan Hydrobromide',
  'ELIDEL',
  'ELIGARD',
  'Elinest',
  'ELIQUIS',
  'Elitek',
  'ELIXOPHYLLIN',
  'Ella',
  'Ellence',
  'Elliotts B',
  'ELMIRON',
  'EluRyng',
  'ELYXYB - celecoxib',
  'Elzonris',
  'Emcyt',
  'EMEND',
  'Emerphed',
  'EMFLAZA',
  'EMGALITY',
  'EMOQUETTE',
  'Empaveli',
  'EMPLICITI',
  'EMSAM',
  'emtricitabine',
  'Emtricitabine and Tenofovir Disoproxil Fumarate',
  'Emtriva',
  'Emverm',
  'Emvita 11',
  'Emvita 2',
  'Emvita 4',
  'Emvita 7',
  'Emvita 8',
  'ENALAPRIL MALEATE',
  'Enalapril Maleate and Hydrochlorothiazide',
  'Enalapril maleate oral solution',
  'Enalaprilat',
  'EnBrace HR',
  'ENBREL',
  'ENDOCET',
  'ENDOMETRIN',
  'Engystol',
  'Enhertu',
  'Enjaymo',
  'EnLyte',
  'Enoxaparin Sodium',
  'Enpresse',
  'ENSKYCE',
  'Enspryng',
  'ENSTILAR',
  'Entacapone',
  'ENTADFI',
  'ENTECAVIR',
  'Entereg',
  'ENTERO Vu 24%',
  'Entocort EC',
  'ENTRESTO',
  'Entyvio',
  'Enulose',
  'Envarsus',
  'Enzoclear Foam',
  'EOVIST',
  'Epaned',
  'Epclusa',
  'Ephedrine Sulfate',
  'Epidiolex',
  'EPIDUO',
  'epiduo forte',
  'EPIFOAM',
  'Epinastine',
  'Epinastine Hydrochloride',
  'Epinephrine',
  'Epinephrine Convenience Kit',
  'Epinephrine Professional',
  'Epinephrine Professional EMS',
  'EpinephrineSnap-EMS',
  'EpinephrineSnap-V',
  'EPIPEN',
  'EPIPEN JR',
  'Epirubicin Hydrochloride',
  'Epitol',
  'EPIVIR',
  'Eplerenone',
  'EPOGEN',
  'epoprostenol',
  'Epoprostenol Sodium',
  'Eprontia',
  'Epstein-Barr Virus',
  'Eptifibatide',
  'EPZICOM',
  'EQUETRO',
  'ER 911',
  'ERAXIS',
  'ERBITUX',
  'Ergocalciferol',
  'Ergocalciferol (Vitamin D2)',
  'Ergocalciferol Capsules,',
  'Ergoloid Mesylates',
  'Ergomar',
  'ergotamine tartrate and caffeine',
  'ERGOTAMINE TARTRATE, CAFFEINE',
  'ERIVEDGE',
  'ERLEADA',
  'Erlotinib',
  'Erlotinib Hydrochloride',
  'ERRIN',
  'Ertaczo',
  'Ertapenem',
  'ertapenem sodium',
  'ERWINASE',
  'Ery',
  'ERYGEL',
  'Ery-Ped',
  'ERY-TAB',
  'Erythrocin Lactobionate',
  'Erythrocin Stearate',
  'Erythromycin',
  'Erythromycin and Benzoyl Peroxide',
  'ERYTHROMYCIN ETHYLSUCCINATE',
  'Erythromycin Gel',
  'Erythromycin Lactobionate',
  'ESBRIET',
  'Escitalopram',
  'escitalopram oxalate',
  'Esgic',
  'ESMOLOL HYDROCHLORIDE',
  'esmolol hydrochloride in sodium chloride',
  'ESOMEPRAZOLE MAGNEISUM D/R',
  'Esomeprazole Magnesium',
  'Esomeprazole sodium',
  'Esomeprazole strontium',
  'Estarylla',
  'Estazolam',
  'Esterified Estrogen and Methyltestosterone',
  'Esterified Estrogens and Methyltestosterone',
  'Estrace',
  'Estradiol',
  'Estradiol / Norethindrone Acetate',
  'ESTRADIOL AND NORETHINDRONE ACETATE',
  'Estradiol Transdermal System',
  'Estradiol Vaginal',
  'Estradiol Vaginal Cream',
  'ESTRADIOL VAGINAL INSERTS',
  'Estradiol Valerate',
  'Estradiol Valerate and Estradiol Valerate/Dienogest',
  'Estring',
  'EstroGel',
  'Eszopiclone',
  'Etesevimab',
  'ETHACRYNATE SODIUM',
  'Ethacrynic Acid',
  'Ethacrynic Sodium',
  'ETHAMBUTOL HYDROCHLORIDE',
  'Ethamolin',
  'ETHOSUXIMIDE',
  'ETHYNODIOL DIACETATE AND ETHINYL ESTRADIOL',
  'Ethyol',
  'Etodolac',
  'Etomidate',
  'Etonogestrel and Ethinyl Estradiol',
  'Etonogestrel/Ethinyl Estradiol',
  'ETOPOPHOS',
  'Etoposide',
  'etravirine',
  'Eucrisa',
  'Eulexin',
  'EUTHYROX',
  'Evamist',
  'Evekeo',
  'Evekeo ODT',
  'Evenity',
  'Everolimus',
  'Evista',
  'Evkeeza',
  'EVOCLIN',
  'EVOMELA',
  'EVOTAZ',
  'Evoxac',
  'EVRYSDI',
  'EVZIO(R) NALOXONE HCl',
  'Exact-Rx SODIUM SULFACETAMIDE and SULFER 10%/5% Cleanser',
  'Exact-Rx Sodium Sulfacetamide Wash 10%',
  'Exelderm',
  'Exelon',
  'ExEm Foam',
  'Exemestane',
  'Exforge',
  'Exforge HCT',
  'Exjade',
  'EXKIVITY',
  'Exondys 51',
  'EXPAREL',
  'EXSERVAN',
  'EXTAVIA',
  'Extended Phenytoin Sodium',
  'EXTINA',
  'EXTRANEAL',
  'EYLEA',
  'Eysuvis',
  'EZALLOR SPRINKLE',
  'E-Z-Disk',
  'Ezetimibe',
  'ezetimibe and simvastatin',
  'E-Z-HD',
  'E-Z-Paque',
  'E-Z-Paste',
  'FABIOR',
  'Fabrazyme',
  'Falmina',
  'Famciclovir',
  'Famotidine',
  'Fanapt',
  'Fareston',
  'FARXIGA',
  'FARYDAK',
  'FASENRA',
  'FASLODEX',
  'FAYOSIM',
  'Febuxostat',
  'FEIBA',
  'Felbamate',
  'Felbatol',
  'Feldene',
  'Felodipine',
  'Fem pH',
  'Fem Repair Non-Preg',
  'Femara',
  'femhrt',
  'Femring',
  'Femynor',
  'FENDIQUE ER',
  'Fenofibrate',
  'Fenofibric Acid',
  'FENOFIBRIC ACID DELAYED-RELEASE',
  'Fenoglide',
  'Fenoprofen Calcium',
  'FENORTHO',
  'Fenovar',
  'Fensolvi',
  'FENTANYL',
  'Fentanyl Buccal',
  'Fentanyl Citrate',
  'Fentanyl System',
  'FENTANYL TRANSDERMAL',
  'FENTANYL TRANSDERMAL system',
  'FENTORA',
  'Feraheme',
  'Ferralet 90',
  'FERRIPROX',
  'Ferrlecit',
  'Ferrum iodatum',
  'Ferumoxytol',
  'fesoterodine fumarate',
  'Fetroja',
  'Fetzima',
  'Fexinidazole',
  'Fexmid',
  'Fiasp',
  'FIBRICOR',
  'Finacea',
  'FINACEA FOAM',
  'Finasteride',
  'FINTEPLA',
  'Fioricet',
  'Fioricet with Codeine',
  'Fiorinal',
  'Fiorinal with Codeine',
  'Firazyr',
  'Firdapse',
  'Fire',
  'FIRMAGON',
  'FIRVANQ',
  'Flac Otic Oil',
  'Flagyl',
  'Flarex',
  'Flavored Colestid',
  'FLAVOXATE HYDROCHLORIDE',
  'Flecainide Acetate',
  'FLECTOR',
  'FLEQSUVY',
  'FLOLAN',
  'FloLipid',
  'FLOMAX',
  'Flo-Pred',
  'Floriva',
  'Flor-Opal Sustained-Release Fluoride',
  'FLOVENT',
  'Floxuridine',
  'Flu Immune',
  'Fluconazole',
  'Fluconazole in Sodium Chloride',
  'flucytosine',
  'Fludarabine',
  'fludarabine phosphate',
  'Fludeoxyglucose',
  'FLUDEOXYGLUCOSE F 18',
  'Fludeoxyglucose F18',
  'Fludeoxyglucose F-18',
  'Fludrocortisone Acetate',
  'Flumazenil',
  'Flumethovix',
  'Flunisolide',
  'Fluocinol Pak',
  'Fluocinolone Acetonide',
  'Fluocinolone Acetonide Oil, 0.01% (Ear Drops)',
  'Fluocinolone Acetonide Topical',
  'Fluocinolone Acetonide Topical Solution USP, 0.01%',
  'Fluocinonide',
  'Fluocinonide Cream',
  'Fluocinonide Gel',
  'Fluopar',
  'FLUORESCEIN',
  'Fluorescein Sodium and Benoxinate Hydrochloride',
  'Fluorescein Sodium and Proparacaine Hydrochloride',
  'FLUORESCITE',
  'Fluoride',
  'Fluorodopa',
  'FLUOROMETHOLONE',
  'Fluoroplex',
  'Fluorouracil',
  'Fluorouracil Cream',
  'Fluovix Plus',
  'Fluoxetine',
  'Fluoxetine HCl',
  'Fluoxetine Hydrochloride',
  'Fluoxiv',
  'Fluphenazine Decanoate',
  'Fluphenazine Hydrochloride',
  'Flurandrenolide',
  'Flurandrenolide Cream',
  'Flurazepam Hydrochloride',
  'Flurbiprofen',
  'Flurbiprofen Sodium',
  'Flutamide',
  'FLUTICASONE',
  'Fluticasone Propionate',
  'fluticasone propionate and salmeterol',
  'Flutone',
  'Fluvastatin',
  'Fluvastatin Sodium',
  'Fluvoxamine Maleate',
  'FML',
  'FML FORTE',
  'Focalin',
  'Focus Medical Oxygen',
  'Folditam',
  'Folic Acid',
  'Foliflex',
  'Folitin-Z',
  'Folixapure',
  'Follistim AQ',
  'Folotyn',
  'Foltamin',
  'Foltrexyl',
  'fomepizole',
  'Fondaparinux Sodium',
  'FORANE',
  'Forfivo',
  'Formoterol fumarate',
  'FORTAMET',
  'Forteo',
  'FORTESTA',
  'FOSAMAX',
  'FOSAMAX PLUS D',
  'Fosamprenavir Calcium',
  'Fosaprepitant',
  'FOSAPREPITANT DIMEGLUMINE',
  'Foscarnet',
  'Foscarnet Sodium',
  'Foscavir',
  'FOSFOMYCIN TROMETHAMINE',
  'Fosinopril Sodium',
  'Fosinopril Sodium and Hydrochlorothiazide',
  'Fosphenytoin',
  'Fosphenytoin Sodium',
  'Fosrenol',
  'Fossaoprin SPG2',
  'Fossaoprin SPG4',
  'FOTIVDA',
  'Fragmin',
  'Fraxinus americana',
  'FreAmine III',
  'Frenna AC',
  'Fresenius Propoven 2%',
  'FROVA',
  'Frovatriptan',
  'Frovatriptan Succinate',
  'FUL-GLO',
  'Fulphila',
  'Fulvestrant',
  'Fuosemide',
  'Furadantin',
  'Furosemide',
  'Fusilev',
  'FUZEON',
  'FYARRO',
  'Fyavolv',
  'Fycompa',
  'Fyremadel',
  'G02 Therapy',
  'Ga-68-DOTATOC',
  'Gaba 300-EZS',
  'Gabapentin',
  'GABITRIL',
  'Gablofen',
  'Gadavist',
  'Galafold',
  'Galantamine',
  'Galantamine Hydrobromide',
  'Gallium',
  'GALLIUM CITRATE GA-67',
  'Gallium Ga-68 PSMA-11',
  'GALZIN',
  'GAMIFANT',
  'Ganciclovir',
  'Ganirelix Acetate',
  'Gastrocrom',
  'Gastrografin',
  'Gatifloxacin',
  'Gattex',
  'GaviLyte - C',
  'GaviLyte - N',
  'GAVILYTE G',
  'GaviLyte-H and Bisacodyl',
  'Gavreto',
  'Gazyva',
  'Gelato APF',
  'Gelato Neutral pH',
  'Gelato Perio Maintenance Rinse',
  'GELNIQUE',
  'Gemcitabine',
  'GEMCITABINE HYDROCHLORIDE',
  'Gemfibrozil',
  'Gemmily',
  'GEMTESA',
  'GEN 7T',
  'Gen7T Plus',
  'GENERESS Fe',
  'Generic drug',
  'Generlac',
  'Gengraf',
  'GENOSYL',
  'GENOTROPIN',
  'Gentak',
  'Gentamicin',
  'Gentamicin Sulfate',
  'Gentamicin Sulfate in Sodium Chloride',
  'Genvoya',
  'Geodon',
  'Gianvi',
  'Giapreza',
  'Gibson Healthcare Buffered Hemostatic Solution',
  'Gilenya',
  'Gilotrif',
  'GIMOTI',
  'GINGIMED',
  'GIVLAARI',
  'Glatiramer Acetate',
  'Glatopa',
  'Gleevec',
  'GLEOLAN',
  'Gleostine',
  'Gliadel',
  'Glimepiride',
  'Glipizide',
  'glipizide and metformin hcl',
  'Glipizide and Metformin Hydrochloride',
  'GLIPIZIDE ER',
  'Glofil-125',
  'Gloperba',
  'GloStrips',
  'GLUCAG0N',
  'GlucaGen',
  'GlucaGen HypoKit',
  'Glucagon',
  'Glucotrol',
  'Glumetza',
  'Glyburide',
  'Glyburide and Metformin Hydrochloride',
  'Glycine',
  'Glycophos',
  'Glycopyrrolate',
  'GLYCYRRHIZA GLABRA',
  'glydo',
  'Glynase',
  'GLYRX-PF',
  'Glytone Skin Lightening',
  'Glyxambi',
  'GOCOVRI',
  'GoLYTELY',
  'Gonak Hypromellose',
  'Gonal-f',
  'GONAL-F RFF',
  'Gonal-f RFF Redi-ject',
  'Goniotaire',
  'GONITRO',
  'GOPRELTO',
  'GRAFCO',
  'Gralise',
  'Granisetron',
  'Granisetron Hydrochloride',
  'GRANIX',
  'GRASS MIX Number 4-S',
  'GRASTEK',
  'GreenGlo',
  'Griseofulvin',
  'Griseofulvin MICROSIZE',
  'grisofulvin',
  'guanfacine',
  'Guanfacine extended-release',
  'Guanfacine Hydrochloride',
  'GUNA-DIUR',
  'Gvoke HypoPen',
  'Gvoke Kit',
  'Gvoke PFS',
  'gynazole 1',
  'HAEMONETICS 0.9 % Sodium Chloride',
  'Haemonetics Additive Solution Formula 3 (AS-3)',
  'Haemonetics Anticoagulant Citrate Dextrose Solution',
  'Haemonetics Anticoagulant Citrate Phosphate Double Dextrose Solution (CP2D)',
  'Haemonetics Anticoagulant Sodium Citrate',
  'Hailey 1.5/30',
  'Hailey 24 Fe',
  'Hailey Fe 1.5/30',
  'HAILEY Fe 1/20',
  'HAIR STIM',
  'Halaven',
  'Halcinonide',
  'Halcion',
  'Haldol',
  'Haldol Decanoate',
  'Halobetasol Propionate',
  'HALOG',
  'Haloperidol',
  'Haloperidol Decanoate',
  'Haloperidol Lactate',
  'Harvoni',
  'Healthy Start Weight and Appetite Support',
  'HEATHER',
  'Hectorol',
  'Heliox',
  'Helium',
  'Helium Oxygen mixture',
  'Helium Oxygen Nitrogen mixture',
  'Helium, Oxygen',
  'Helium/Oxygen Mix',
  'Helium/Oxygen Mixture 70/30',
  'Helium/Oxygen Mixture 80/20',
  'Hemabate',
  'Hemady',
  'HEMANGEOL',
  'HEMATOGEN',
  'Hematogen FA',
  'HEMATOGEN FORTE',
  'Hemlibra',
  'Hemmorex-HC',
  'Hemoban',
  'Hemostat',
  'Hemox A',
  'HepaGam B',
  'Heparin Sodium',
  'Heparin Sodium and Dextrose',
  'Heparin Sodium in Dextrose',
  'Heparin Sodium in Sodium Chloride',
  'HepatAmine',
  'Hepsera',
  'Herceptin',
  'Herceptin Hylecta',
  'HERZUMA',
  'HESPAN',
  'Hetastarch in Sodium Chloride',
  'Hetlioz',
  'Hexatrione',
  'Hextend',
  'HICON',
  'HiDex 6-day',
  'HIPPOZAENINUM',
  'HIPREX',
  'Histamine Positive',
  'HOMATROPINE HYDROBROMIDE OPHTHALMIC',
  'Honey Bee Hymenoptera Venom',
  'Honey Bee Hymenoptera Venom Multidose',
  'Honey Bee Hymenoptera Venom Venomil Diagnostic',
  'Honey Bee Hymenoptera Venom Venomil Maintenance',
  'Honey Bee Venom',
  'Horizant',
  'House Dust Mite, Dermatophagoides farinae',
  'House Dust Mite, Dermatophagoides pteronyssinus',
  'H-Paxin',
  'Humalog',
  'Human Papilloma Virus (HPV)',
  'Humatin',
  'HUMATROPE',
  'Humco Strong Iodine',
  'Humira',
  'HYALURONIDASE',
  'HYCAMTIN',
  'Hycodan',
  'Hydralazine',
  'HYDRALAZINE HCL',
  'HYDRALAZINE HYDROCHLORIDE',
  'HYDREA',
  'Hydrochlorothiazide',
  'HYDROCODONE /APAP',
  'Hydrocodone Bitartrate',
  'Hydrocodone Bitartrate and Acetaminophen',
  'Hydrocodone Bitartrate and Aspirin',
  'Hydrocodone Bitartrate and Homatropine Methylbromide',
  'Hydrocodone Bitartrate and Ibuprofen',
  'Hydrocodone Polistirex and Chlorpheniramine Polistirex',
  'HYDROCORTISONE',
  'Hydrocortisone Acetate',
  'hydrocortisone acetate pramoxine HCl',
  'Hydrocortisone Acetate Pramoxine Hydrochloride',
  'Hydrocortisone Acetate, Iodoquinol',
  'hydrocortisone and acetic acid',
  'Hydrocortisone Butyrate',
  'Hydrocortisone Iodoquinol',
  'Hydrocortisone Rectal Suspension (Retention)',
  'Hydrocortisone Valerate',
  'hydrocortisone valerate cream',
  'HYDROCORTISONE, IODOQUINOL',
  'Hydromet',
  'Hydromorphone Hydrochloride',
  'Hydro-Q',
  'hydroquinone',
  'HYDROQUINONE 4%',
  'Hydroquinone cream',
  'Hydroxocobalamin',
  'Hydroxychloroquine Sulfate',
  'Hydroxyprogesterone Caproate',
  'HYDROXYUREA',
  'Hydroxyzine',
  'HYDROXYZINE HCL',
  'Hydroxyzine Hydrochloride',
  'Hydroxyzine Pamoate',
  'HYFTOR',
  'HYLENEX Recombinant',
  'Hyophen',
  'Hyoscyamine',
  'Hyoscyamine Sulfate',
  'Hyoscyamine Sulfate Drops',
  'Hyoscyamine Sulfate Extended-Release',
  'Hyoscyamine Sulfate ODT',
  'Hyoscyamine Sulfate SL',
  'Hyoscyamine Sulfate TAB',
  'Hyosyne',
  'Hyperbaric Chamber Mix',
  'HYRDROCODONE APAP',
  'Hyronan',
  'Hysingla ER',
  'HYZAAR',
  'ibandronate sodium',
  'Ibrance',
  'IBSRELA',
  'IBU',
  'IBUPAK',
  'Ibuprofen',
  'Ibuprofen and famotidine',
  'Ibuprofen Lysine',
  'Ibutilide Fumarate',
  'Icatibant',
  'IC-Green',
  'Iclevia',
  'Iclofenac CP',
  'Iclusig',
  'Icosapent',
  'Icosapent Ethyl',
  'Idamycin PFS',
  'Idarubicin Hydrochloride',
  'Idhifa',
  'IFEX',
  'Ifosfamide',
  'Ilaris',
  'ILEVRO',
  'ILLUCCIX',
  'Iloperidone',
  'ILUMYA',
  'Iluvien',
  'Imatinib',
  'Imatinib Mesylate',
  'Imbruvica',
  'Imdevimab',
  'IMFINZI',
  'Imipenem and Cilastatin',
  'Imipramine Hydrochloride',
  'Imipramine Pamoate',
  'Imiquimod',
  'IMITREX',
  'Imlygic',
  'IMPAVIDO',
  'IMPEKLO',
  'Impoyz',
  'IMUFLEX WB-RP Blood Bag System with Integral Whole Blood Leukocyte Reduction Filter (Removing Platelets) with Diversion Blood Sampling Arm Anticoagulant Citrate Phosphate Dextrose (CPD) AND OPTISOL (AS-5) Red Cell Preservative',
  'imuflex wb-sp blood bag system with integral whole blood leukocyte reduction filter (saving platelets) with diversion blood sampling arm',
  'IMUFLEX WB-SP Blood Bag System with Integral Whole Blood Leukocyte Reduction Filter (Saving Platelets) with Diversion Blood Sampling Arm Anticoagulant Citrate Phosphate Dextrose (CPD) and OPTISOL (AS-5) Red Cell Preservative',
  'IMURAN',
  'IMVEXXY',
  'Inbrija',
  'Incassia',
  'Increlex',
  'Incruse Ellipta',
  'Indapamide',
  'INDERAL',
  'Inderal XL',
  'Indigo Carmine',
  'Indium DTPA In 111',
  'INDIUM IN 111 CHLORIDE',
  'Indium in 111 Oxyquinoline',
  'Indocin',
  'Indocyanine Green',
  'Indomethacin',
  'INFANT 4.2% SODIUM BICARBONATE',
  'Infant Dextrose',
  'INFASURF',
  'INFeD',
  'Inflammacin',
  'Inflatherm',
  'INFLECTRA',
  'INFLIXIMAB',
  'INFUGEM',
  'INFUMORPH 200',
  'INFUMORPH 500',
  'Infuvite Adult Multiple Vitamins',
  'INGREZZA',
  'Injectafer',
  'INJURY HP',
  'INLYTA',
  'Inmazeb',
  'InnoPran XL',
  'INOmax',
  'INQOVI',
  'Inrebic',
  'Inspra',
  'Insulin Aspart',
  'Insulin Aspart Protamine and Insulin Aspart',
  'Insulin Aspart Protamine and Insulin Aspart',
  'Insulin Diluting Medium for NovoLog',
  'Insulin Glargine',
  'Insulin Lispro',
  'Insulin Lispro Protamine and Insulin Lispro Injectable Suspension',
  'Intelence',
  'Intermezzo',
  'InterSol',
  'Intralipid',
  'Intrarosa',
  'INTRON A',
  'Introvale',
  'Intuniv',
  'INVANZ',
  'INVEGA',
  'INVEGA HAFYERA',
  'INVEGA SUSTENNA',
  'INVEGA TRINZA',
  'Inveltys',
  'Invirase',
  'INVOKAMET',
  'INVOKAMET XR',
  'INVOKANA',
  'IODOQUINOL, HYDROCORTISONE ACETATE, ALOE POLYSACCHARIDES',
  'Ioflupane I 123',
  'Ionite APF',
  'Ionite R',
  'Ionosol MB and Dextrose',
  'IOPIDINE',
  'Ipratropium Bromide',
  'Ipratropium Bromide and Albuterol Sulfate',
  'IQ Dental Mepivacaine',
  'Irbesartan',
  'Irbesartan and Hydrochlorothiazide',
  'IRESSA',
  'Irinotecan hydrochloide',
  'Irinotecan Hydrochloride',
  'Iris 60 Second APF',
  'Iris tenax',
  'IRON DEXTRAN',
  'IROSPAN 24/6',
  'ISENTRESS',
  'Isibloom',
  'Isoflurane',
  'Isolyte P in Dextrose',
  'Isolyte S',
  'Isolyte S pH 7.4',
  'Isoniazid',
  'Isoplate',
  'ISOPROTERENOL',
  'ISOPROTERENOL HYDROCHLORIDE',
  'Isopto Atropine',
  'ISOPTO CARPINE',
  'Isordil',
  'Isosorbide',
  'Isosorbide Dinitrate',
  'Isosorbide Mononitrate',
  'Isosorbide Mononitrate ER',
  'Isosulfan Blue',
  'Isotretinoin',
  'ISOVUE',
  'ISOVUE-M',
  'ISOXSUPRINE HYDROCHLORIDE',
  'Isradipine',
  'Istalol',
  'ISTODAX',
  'Isturisa',
  'Isuprel',
  'Itraconazole',
  'IV Solution Stabilizer',
  'IXEMPRA',
  'Ixinity',
  'IXOBA M',
  'Jadenu',
  'JAIMIESS',
  'JAKAFI',
  'JALYN',
  'Jantoven',
  'JANUMET',
  'JANUVIA',
  'Jardiance',
  'Jasmiel',
  'Jatenzo',
  'Jeanatope',
  'JELMYTO',
  'Jemperli',
  'Jencycla',
  'Jentadueto',
  'Jentadueto XR',
  'Jeuveau',
  'Jevtana',
  'Jinteli',
  'Jolessa',
  'JORNAY PM',
  'JUBLIA',
  'Juleber',
  'Juluca',
  'Junel',
  'Junel Fe',
  'Junel Fe 1.5/30',
  'Junel Fe 1/20',
  'Juniperus virginiana',
  'Just Right 5000',
  'Juulissa Pharmapak',
  'Juxtapid',
  'Jynarque',
  'K Phos',
  'Kabiven',
  'KADCYLA',
  'Kadian',
  'Kaitlib Fe',
  'Kalbitor',
  'Kaletra',
  'Kalliga',
  'Kalydeco',
  'Kanjinti',
  'KANUMA',
  'KAPSPARGO',
  'Kapvay',
  'Karbinal',
  'Kariva',
  'Katerzia',
  'KAZANO',
  'Kelnor 1/35',
  'Kelnor 1/50',
  'Kenalog',
  'KENALOG-10',
  'KENALOG-40',
  'KENALOG-80',
  'KENGREAL',
  'Kentucky Bluegrass (June) Standardized',
  'Kepivance',
  'Keppra',
  'Keralyt',
  'Kerendia',
  'Kerydin',
  'KESIMPTA',
  'Ketaconazole',
  'KETALAR',
  'Ketamine Hydrochloride',
  'Ketoconazole',
  'Ketoconazole Cream, 2%',
  'Ketodan',
  'Ketoprofen',
  'Ketorocaine L Kit',
  'Ketorocaine LM Kit',
  'Ketorolac Tromethamine',
  'Keveyis',
  'KEVZARA',
  'KEYTRUDA',
  'KHAPZORY',
  'KIDS CHOICE',
  'KIMMTRAK',
  'Kimyrsa',
  'Kineret',
  'KINEVAC',
  'KISQALI',
  'KISQALI FEMARA CO-PACK',
  'Kit for the preparation of Lymphoseek (technetium Tc 99m tilmanocept)',
  'Kit for the Preparation of Technetium Tc 99m Mebrofenin',
  'Kit for the Preparation of Technetium Tc 99M Medronate',
  'Kit for the Preparation of Technetium Tc99m Mertiatide',
  'Kit for the Preparation of Technetium Tc99m Pyrophosphate',
  'Kit for the Preparation of Technetium Tc99m Sestamibi',
  'Kit for the Prepartion of Technetium Tc99m Sulfur Colloid',
  'Kitabis Pak',
  'Klaron',
  'Klisyri',
  'Klonopin',
  'KLOR-CON',
  'KLOR-CON M',
  'KLOR-CON M20',
  'Klor-Con Sprinkle',
  'KLOR-Con/EF',
  'KLOXXADO',
  'KOLORZ NEUTRAL FLUORIDE FOAM',
  'KOLORZ SIXTY SECOND FLUORIDE',
  'KOLORZ SIXTY SECOND FLUORIDE FOAM',
  'KOMBIGLYZE',
  'Korlym',
  'Korsuva',
  'K-O-R-T and Sweet Vernal Standardized Grass Pollen Mix',
  'K-O-R-T Standardized Grass Pollen Mix',
  'KOSELUGO',
  'K-O-T Standardized Grass Pollen Mix',
  'K-Phos',
  'Krintafel',
  'Kristalose',
  'Krystexxa',
  'K-Tab',
  'Kurvelo',
  'Kuvan',
  'KYBELLA',
  'Kyleena',
  'KYNMOBI',
  'KYPROLIS',
  'Labetalol HCl',
  'Labetalol HCl in Dextrose',
  'Labetalol HCl in Sodium Chloride',
  'Labetalol Hydrochloride',
  'Lacellate Solution - 1000',
  'Lacellate Solution - 250',
  'Lacellate Solution - 500',
  'Lacosamide',
  'Lacrisert',
  'Lactated Ringers',
  'Lactated Ringers and Dextrose',
  'Lactated Ringers Irrigation',
  'LACTULOSE',
  'Lactulose Solution',
  'LAMICTAL',
  'LAMIVUDINE',
  'LAMIVUDINE and ZIDOVUDINE',
  'Lamotrigine',
  'Lamotrigine Extended Release',
  'LAMPIT',
  'LANOXIN',
  'Lanreotide Acetate',
  'Lansoprazole',
  'Lansoprazole, Amoxicillin and Clarithromycin',
  'Lanthanum carbonate',
  'Lantus',
  'Lantus Solostar',
  'Lapatinib',
  'Lapis albus',
  'Larin 1.5/30',
  'Larin 1/20',
  'Larin 24 Fe',
  'Larin Fe 1.5/30',
  'Larin Fe 1/20',
  'Larissia',
  'Lasix',
  'LASTACAFT',
  'LATANOPROST',
  'LATISSE',
  'Latrodectus mactans',
  'Latuda',
  'Layolis Fe',
  'LAZANDA',
  'Ledipasvir and Sofosbuvir',
  'Leena',
  'Leep RediKit',
  'Leflunomide',
  'LEMTRADA',
  'Lenalidomide',
  'Lenvima',
  'LEQVIO',
  'Lescol',
  'Lessina',
  'Letairis',
  'Letrozole',
  'Leucoflex CGP',
  'Leucovorin Calcium',
  'LEUKERAN',
  'Leukine',
  'Leukotrap - AS-3 Solution',
  'Leukotrap - CP2D Solution',
  'Leukotrap WB System',
  'Leukotrap WB System - AS3',
  'Leukotrap WB System - CP2D',
  'Leuprolide Acetate',
  'Levalbuterol',
  'Levalbuterol Hydrochloride',
  'levalbuterol inhalation',
  'Levalbuterol Inhalation Solution',
  'Levalbuterol tartrate HFA inhalation',
  'Levamlodipine',
  'Levbid',
  'Levemir',
  'LEVERTIRACETAM',
  'Levetiracetam',
  'LEVETIRACETAM EXTENDED RELEASE',
  'Levetiracetam in Sodium Chloride',
  'Levetiractam',
  'Levobunolol Hydrochloride',
  'Levocarnitine',
  'Levocetirizine Dihydrochloride',
  'Levofloxacin',
  'Levoleucovorin',
  'Levoleucovorin Calcium',
  'Levomilnacipran',
  'Levonest',
  'LEVONORGESTREL AND ETHINYL ESTRADIOL',
  'LEVONORGESTREL AND ETHINYL ESTRADIOL AND ETHINYL ESTRADIOL',
  'LEVOPHED',
  'LEVOPHED(R) NOREPINEPHRINE BITARTRATE',
  'Levora',
  'Levorphanol Tartrate',
  'LEVO-T',
  'Levothroxine Sodium',
  'Levothyroxine Sodium',
  'LEVOXYL',
  'Levsin',
  'LEVULAN KERASTICK',
  'Lexapro',
  'LEXETTE',
  'LEXISCAN',
  'LEXISCAN(R) (REGADENOSON)',
  'LEXIVA',
  'Lialda',
  'Librax',
  'LIBTAYO',
  'LICART',
  'Lidenzal 1%',
  'Lidenzal 2%',
  'LIDO BDK',
  'Lido Rx',
  'Lidocaine',
  'Lidocaine and Prilocaine',
  'Lidocaine and Prilocaine Cream',
  'Lidocaine and Tetracaine',
  'LIDOCAINE HCI',
  'LIDOCAINE HCI AND DEXTROSE',
  'LIDOCAINE HCI AND EPINEPHRINE',
  'LIDOCAINE HCI AND EPINEPHRINE WITH EPINEPHRINE',
  'LIDOCAINE HCl',
  'Lidocaine HCl - Hydrocortisone Acetate',
  'LIDOCAINE HCl and EPINEPHRINE',
  'Lidocaine Hydrochloride',
  'Lidocaine Hydrochloride and Dextrose',
  'Lidocaine Hydrochloride and Epinephrine',
  'Lidocaine Hydrochloride and Epinephrine Bitartrate',
  'Lidocaine Hydrochloride and Hydrocortisone Acetate',
  'Lidocaine Viscous',
  'Lidocanna',
  'Lidocort',
  'LIDODERM',
  'Lidogel',
  'Lidolog Kit',
  'Lidomark 1/5',
  'Lidomark 2/5',
  'LidoPure Patch',
  'Lidorex',
  'LIDOTHOL',
  'Lidotor',
  'Lidovix L',
  'Lidoxryl',
  'Lignospan Forte',
  'Lignospan Standard',
  'LILETTA',
  'Lillow',
  'Lincocin',
  'LINCOMYCIN',
  'Lindane',
  'Linezolid',
  'Linzess',
  'Lioresal (baclofen)',
  'Liothyronine Sodium',
  'LIPIODOL',
  'Lipitor',
  'Lipofen',
  'Liquid B',
  'Liquid Polibar Plus',
  'Lisinopril',
  'Lisinopril and Hydrochlorothiazide',
  'Lisinopril with Hydrochlorothiazide',
  'Lisinopril/HCTZ',
  'Lisinoril',
  'Lithium',
  'Lithium Carbonate',
  'LITHOBID',
  'Lithostat',
  'Livalo',
  'Livmarli',
  'Livtencity',
  'Lixtraxen 1%',
  'LMD in Dextrose',
  'LMD in Sodium Chloride',
  'LMR Plus',
  'Lo Loestrin Fe',
  'Lo Simpesse',
  'LOCAMETZ',
  'Locoid',
  'Locoid Lipocream',
  'Lodosyn',
  'Loestrin',
  'LOFENA',
  'LoJaimiess',
  'LOKELMA',
  'LOMAIRA',
  'Lomotil',
  'LONHALA MAGNAIR',
  'LONSURF',
  'Loperamide Hydrochloride',
  'Lopid',
  'Lopinavir and ritonavir',
  'Lopinavir-Ritonavir',
  'Lopreeza',
  'Lopressor',
  'Loprox',
  'Lorazepam',
  'Lorbrena',
  'LOREEV XR',
  'Lortab',
  'LORYNA',
  'Lorzone',
  'LOSARTAN POT/HCTZ',
  'Losartan Potassium',
  'Losartan Potassium and Hydrochlorothiazide',
  'Losartan Potassium HCTZ',
  'Losartan potassium Tablets, 100 mg',
  'Losartan potassium Tablets, 25 mg',
  'Losartan potassium Tablets, 50 mg',
  'LoSeasonique',
  'Losortan Potassium',
  'LOTEMAX',
  'Lotemax SM',
  'Lotensin',
  'Lotensin HCT',
  'Loteprednol Etabonate',
  'Lotrel',
  'LOTRONEX',
  'Lovastatin',
  'LOVAZA',
  'Lovenox',
  'Low-Ogestrel',
  'Loxapine',
  'Lo-Zumandimine',
  'Lubiprostone',
  'Lucemyra',
  'LUCENTIS',
  'Ludaxine',
  'LULICONAZOLE',
  'LUMAKRAS',
  'Lumason',
  'lumicain',
  'LUMIGAN',
  'Lumizyme',
  'LUMOXITI',
  'Lunesta',
  'Lupaneta Pack',
  'LUPKYNIS',
  'Lupron Depot',
  'Lupron Depot-PED',
  'Lurasidone Hydrochloride',
  'Lutathera',
  'Lutera',
  'Luxiq',
  'Luzu',
  'LYBALVI',
  'Lycopus virginicus',
  'Lydexa 4.12%',
  'Lyleq',
  'LYLLANA',
  'LymePak',
  'Lymph Detox',
  'Lymphomyosot X',
  'Lynparza',
  'Lyrica',
  'Lyrica CR',
  'Lysodren',
  'LYSSIN',
  'Lysteda',
  'LYUMJEV',
  'Lyvispah',
  'LYZA',
  'Macrilen',
  'Macrobid',
  'Macrodantin',
  'Mafenide acetate',
  'Magnesium Chloride',
  'Magnesium Sulfate',
  'Magnesium Sulfate in 5% Dextrose',
  'Magnesium Sulfate in Dextrose',
  'Magnesium Sulfate in Water',
  'Magnevist',
  'Major Oral Rinse',
  'Makena',
  'MALARONE',
  'Malathion',
  'MANGANESE',
  'Manganese Sulfate',
  'Mannitol',
  'Maraviroc',
  'Marbeta 25 Kit',
  'Marbeta L Kit',
  'Marcaine',
  'Marcaine Spinal',
  'MARCAINE WITH EPINEPHRINE',
  'Mardex 25 Kit',
  'MARGENZA',
  'Marinol',
  'Marlido 25 Kit',
  'Marlido Kit',
  'MARLISSA',
  'Marplan',
  'Marqibo',
  'Marvona SUIK',
  'Matulane',
  'Matzim LA',
  'Mavenclad',
  'Mavyret',
  'MAXALT',
  'MAXALT-MLT',
  'Maxidex',
  'MAXITROL',
  'MAXZIDE',
  'MAXZIDE-25',
  'MAYZENT',
  'MD GASTROVIEW',
  'Me NaPhos MB Hyo 1',
  'Meadow Fescue Grass, Standardized',
  'Mecamylamine Hydrochloride',
  'Meclizine Hydrocloride',
  'Meclofenamate Sodium',
  'MEDICAL AIR',
  'Medical Oxygen Compressed',
  'Medicated Buccal DNA Collection Kit',
  'Medicated Buccal DNA Collection Kit 2',
  'Medorrhinum',
  'Medrol',
  'Medroloan II SUIK',
  'Medroloan SUIK',
  'Medroxyprogesterone',
  'Medroxyprogesterone Acetate',
  'Mefenamic Acid',
  'Mefloquine Hydrochloride',
  'Megatope',
  'Megestrol Acetate',
  'Mekinist',
  'MEKTOVI',
  'Melodetta 24 Fe',
  'MELOXICAM',
  'Melphalan',
  'Melphalan Hydrochloride',
  'Memantine',
  'Memantine and Donepezil Hydrochlorides Extended-release',
  'Memantine Hydrochloride',
  'MEMBRANEBLUE',
  'Menadione Phenolic',
  'MENEST',
  'Menopur',
  'Menostar',
  'MENTAX',
  'Meperidine Hydrochloride',
  'Mephyton',
  'Mepivacaine',
  'Mepivacaine Hydrochloride',
  'MEPROBAMATE',
  'MEPRON',
  'MEPSEVII',
  'Mercaptopurine',
  'Meropenem',
  'Meropenem and Sodium Chloride',
  'MERREM',
  'MERZEE',
  'Mesalamine',
  'Mesalamine Rectal',
  'MESNA',
  'MESNEX',
  'Mestinon',
  'Metaproterenol Sulfate',
  'Metaxalone',
  'Metformin',
  'Metformin ER 500 mg',
  'Metformin ER 750 mg',
  'Metformin HCl',
  'Metformin Hydrochloride',
  'METFORMIN HYDROCHLORIDE EXTENDED RELEASE',
  'Metformin Hydrochloride Oral Solution',
  'Metformin Hydrochoride',
  'Methadone Hydrochloride',
  'Methadone Hydrocloride',
  'METHADOSE',
  'METHADOSE DISPERSIBLE',
  'Methamphetamine Hydrochloride',
  'methazolamide',
  'Methenamine Hippurate',
  'Methenamine Mandelate',
  'Methergine',
  'Methimazole',
  'METHITEST',
  'Methocarb 500-EZS',
  'Methocarbamol',
  'Methocarbamol and Aspirin',
  'Methocarbamol Tablets, USP, 500 mg',
  'Methocarbamol Tablets, USP, 750 mg',
  'Methotrexate',
  'Methotrexate Sodium',
  'Methoxsalen',
  'METHSCOPOLAMINE BROMIDE',
  'Methyldopa',
  'Methylene Blue',
  'Methylergonovine Maleate',
  'Methylin',
  'Methylphenidate',
  'Methylphenidate HCl',
  'Methylphenidate Hydrochloride',
  'Methylphenidate Hydrochloride (LA)',
  'methylphenidate hydrochloride CD',
  'METHYLPHENIDATE HYDROCHLORIDE EXTENDED RELEASE',
  'Methylpred DP',
  'MethylPREDNISolone',
  'Methylprednisolone Acetate',
  'Methylprednisolone Sodium Succinate',
  'MethylTESTOSTERone',
  'Metoclopramide',
  'METOCLOPRAMIDE hydrochloride',
  'Metolazone',
  'Metopirone',
  'Metoprolol',
  'Metoprolol Succinate',
  'Metoprolol Succinate ER',
  'Metoprolol Tartrate',
  'Metoprolol Tartrate and Hydrochlorothiazide',
  'MetroCream',
  'METROGEL',
  'MetroLotion',
  'Metronidazole',
  'Metronidazole Topical Cream',
  'Metronidazole Topical Gel',
  'metronidazole vaginal',
  'Metronidazole250 mg',
  'Metronidazole500 mg',
  'Metyrosine',
  'Mexiletine Hydrochloride',
  'Miacalcin',
  'Micafungin',
  'Micardis',
  'Micardis HCT',
  'MICROGESTIN 1.5/30',
  'MICROGESTIN 1/20',
  'Microgestin 24 Fe',
  'MICROGESTIN Fe 1.5/30',
  'MICROGESTIN Fe 1/20',
  'Midazolam',
  'Midazolam Hydrochloride',
  'Midodrine HCl',
  'Midodrine Hydrochloride',
  'MIDWEST MIX OF STANDARDIZED GRASS',
  'Mifepristone',
  'MIGERGOT',
  'Miglitol',
  'Miglustat',
  'Migranal',
  'Migranow',
  'Mili',
  'MILLIPRED',
  'Milnacipran HCl',
  'Milrinone Lactate',
  'Milrinone Lactate in Dextrose',
  'Mimvey',
  'Minastrin 24 Fe',
  'Minipress',
  'Minivelle',
  'Minocin',
  'Minocycline',
  'minocycline hydrochloride',
  'Minolira Extended Release',
  'Miochol E',
  'MIOSTAT',
  'Mirapex',
  'Mircera',
  'Mircette',
  'Mirena',
  'Mirtazapine',
  'Mirvaso',
  'Misoprostol',
  'MITIGARE',
  'MITIGO',
  'Mitomycin',
  'Mitosol',
  'mitoXANTRONE',
  'MIX OF 5 STANDARDIZED GRASS POLLEN',
  'MIX OF 6 STANDARDIZED GRASS POLLEN',
  'MIX OF 7 STANDARDIZED GRASS POLLEN',
  'Mixed Salts of a Single Entity Amphetamine Product',
  'Mixed Vespid Hymenoptera Venom',
  'Mixed Vespid Hymenoptera Venom Multidose',
  'Mixed Vespid Hymenoptera Venom Venomil Maintenance',
  'Mixed Vespid Venom',
  'MLK F1 Kit',
  'MLK F3 Kit',
  'MLK F4 Kit',
  'MLK Kit F2',
  'M-Natal Plus',
  'Mobic',
  'Modafinil',
  'Moexipril Hydrochloride',
  'Mold Antigens',
  'Molindone Hydrochloride',
  'molnupiravir',
  'Mometasone Furoate',
  'MONJUVI',
  'Monobasic Sodium Phosphate and Dibasic Sodium Phosphate',
  'Monoferric',
  'Monoket',
  'Mono-Linyah',
  'MonoNessa',
  'Monsels Solution',
  'Montelukast',
  'Montelukast Sodium',
  'Monurol',
  'Morbillinum',
  'Morcin',
  'Morphine Sulfate',
  'MOTEGRITY',
  'Motofen',
  'MOVANTIK',
  'MoviPrep',
  'MOXEZA',
  'Moxicaine kit',
  'Moxidectin',
  'Moxifloxacin',
  'Moxifloxacin Hydrochloride',
  'Moxifloxacin Hydrochloride Tablets, 400 mg',
  'Moxifloxacin Ophthalmic Solution',
  'Mozobil',
  'MS APF',
  'MS Contin',
  'Mulpleta',
  'Multaq',
  'MultiHance',
  'Multi-Specialty Kit',
  'Multitam',
  'Multitrace -4 Pediatric',
  'Multitrace-4 Neonatal',
  'Multitrace-5',
  'Multi-Vitamin Drops with Fluoride and Iron',
  'Multivitamin with Fluoride',
  'Multi-Vitamin with Fluoride',
  'Multrys',
  'Mupirocin',
  'MUSE',
  'MUTAMYCIN',
  'MVASI',
  'Myalept',
  'Myambutol',
  'Mycamine',
  'Mycapssa',
  'Mycobutin',
  'Mycophenolate Mofetil',
  'Mycophenolic Acid',
  'MYDAYIS',
  'Mydriacyl',
  'Myfembree',
  'Myfortic',
  'MYLERAN',
  'Mylotarg',
  'Myobloc',
  'Myorisan',
  'Myoview',
  'Myrbetriq',
  'Mysoline',
  'MYTESI',
  'MYXREDLIN',
  'N/A',
  'NA',
  'NABI-HB',
  'Nabumetone',
  'Nabumetone 1000 mg',
  'Nabumetone 500 mg',
  'Nabumetone 750 mg',
  'Nacellate Solution 0.9% - 1000mL',
  'Nacellate Solution 0.9% - 100mL',
  'Nacellate Solution 0.9% - 250mL',
  'Nacellate Solution 0.9% - 500mL',
  'Nadolol',
  'NAFCILLIN',
  'Nafcillin Sodium',
  'NAFTIFINE HYDROCHLORIDE',
  'Naftin',
  'NAGLAZYME',
  'NALBUPHINE HCI',
  'Nalbuphine Hydrochloride',
  'Nalfon',
  'NALMEFENE HYDROCHLORIDE',
  'Nalocet',
  'NALOXONE HCI',
  'Naloxone Hydrochloride',
  'Naloxone Hydrochloride Injection, USP, Auto-Injector',
  'NALTREXONE HYDROCHLORIDE',
  'Namenda',
  'Namzaric',
  'Naprelan',
  'Naprosyn',
  'Naproxen',
  'Naproxen and Esomeprazole Magnesium',
  'Naproxen Oral Suspension',
  'Naratriptan',
  'Narcan',
  'NARCAN NALOXONE HCI',
  'Nardil',
  'NAROPIN',
  'Nascobal',
  'NataChew',
  'NATACYN',
  'Natazia',
  'Nateglinide',
  'Natesto',
  'NATPARA (parathyroid hormone)',
  'Natroba',
  'Nayzilam',
  'nebivolol',
  'Nebivolol Hydrochloride',
  'NebuPent',
  'Necon',
  'Nedocromil Sodium',
  'Nefazodone Hydrochloride',
  'Nelarabine',
  'Nembutal Sodium',
  'Neo Polycin',
  'Neo Polycin HC',
  'NeoBenz Micro Plus Pack',
  'Neomycin and Polymyxin B Sulfates',
  'Neomycin and Polymyxin B Sulfates and Bacitracin Zinc',
  'Neomycin and Polymyxin B Sulfates and Dexamethasone',
  'NEOMYCIN AND POLYMYXIN B SULFATES AND GRAMICIDIN',
  'Neomycin and Polymyxin B Sulfates and Hydrocortisone',
  'Neomycin and Polymyxin B Sulfates and Hydrocortisone Otic Suspension',
  'Neomycin and Polymyxin B Sulfates, and Bacitracin Zinc',
  'Neomycin and Polymyxin B sulfates, Bacitracin zinc',
  'Neomycin and Polymyxin B Sulfates, Bacitracin Zinc and Hydrocortisone',
  'Neomycin and Polymyxin B Sulfates, Bacitracin Zinc, and Hydrocortisone',
  'Neomycin Polymyxin B Sulfates and Dexamethasone',
  'Neomycin Sulfate',
  'NEONATAL Complete',
  'NEONATAL DHA',
  'NEONATAL FE',
  'NEONATAL19',
  'NeoProfen',
  'Neoral',
  'Neostigmine',
  'NEOSTIGMINE METHYLSULFATE',
  'Neo-Synalar',
  'NephPlex Rx',
  'Nephron FA',
  'NephroScan',
  'Nerlynx',
  'Nesacaine',
  'Nesina',
  'NESTABS',
  'NESTABS DHA',
  'Nestabs ONE',
  'NETSPOT',
  'Neuac',
  'Neuac Kit',
  'Neulasta',
  'NeuLumEX',
  'NEUPOGEN',
  'Neupro',
  'Neuraceq',
  'Neuralgo Rheum',
  'NEUROLITE',
  'Neuromaquel Neuroma/Anti-Inflammatory System',
  'Neurontin',
  'NEUTRA MAXX 5000',
  'Neutral Sodium Fluoride',
  'NEUTRAMAXX 5000',
  'NEUTRAMAXX 5000 PLUS TURBO',
  'NEUTRAMAXX 5000 TCP',
  'NEVANAC',
  'Nevirapine',
  'Nexavar',
  'Nexesta Fe',
  'Nexiclon XR',
  'NEXIUM',
  'Nexletol',
  'Nexlizet',
  'Nexplanon',
  'Nexterone',
  'NEXTERONE (AMIODARONE HCI)',
  'Nextstellis',
  'Nexviazyme',
  'Niacin',
  'Niacor',
  'Niaspan',
  'Nicardipine Hydrochloride',
  'Nicotrol',
  'Nifedipine',
  'Niferex',
  'Nikki',
  'Nilandron',
  'Nilutamide',
  'Nimbex',
  'Nimodipine',
  'NINLARO',
  'Nipent',
  'NIPRIDE RTU',
  'Nisoldipine',
  'Nitazoxanide',
  'NITHIODOTE',
  'Nitisinone',
  'NITRO-BID',
  'NITRO-DUR',
  'Nitrofurantion',
  'Nitrofurantion Macrocrystals',
  'Nitrofurantoin',
  'Nitrofurantoin (monohydrate/macrocrystals)',
  'Nitrofurantoin Macrocrystals',
  'Nitrofurantoin Mono',
  'NITROFURANTOIN MONOHYDRATE MACROCRYSTALLINE',
  'Nitrofurantoin Monohydrate/ Macrocrystalline',
  'Nitrofurantoin monohydrate/macrocrystals',
  'Nitrogen',
  'Nitrogen Oxygen Mix',
  'Nitrogen, Refrigerated',
  'Nitroglycerin',
  'Nitroglycerin In Dextrose',
  'NITROGLYCERIN LINGUAL',
  'Nitroglycerin Transdermal Infusion System',
  'Nitroglycerin Transdermal System',
  'NITROLINGUAL',
  'NitroMist',
  'Nitrostat',
  'Nitro-Time',
  'Nitrous Oxide',
  'Nitrous Oxide Sedara',
  'NITYR',
  'Nivestym',
  'Nizatidine',
  'NOCDURNA',
  'Nolix',
  'Nora BE',
  'Norditropin',
  'Norelgestromin and Ethinly Estradiol',
  'Norepinephrine Bitartrate',
  'Norethindrone',
  'Norethindrone Acetate',
  'NORETHINDRONE ACETATE AND ETHINYL ESTRADIOL',
  'Norethindrone Acetate and Ethinyl Estradiol and Ferrous Fumarate',
  'norethindrone acetate and ethinyl estradiol, and ferrous fumarate',
  'NORETHINDRONE AND ETHINYL ESTRADIOL AND FERROUS FUMARATE',
  'Norgesic Forte',
  'Norgestimate and Ethinyl Estradiol',
  'Noritate',
  'Norlyda',
  'NORMOSOL-M AND DEXTROSE',
  'Normosol-R',
  'Normosol-R and Dextrose',
  'Norpace',
  'Norpace CR',
  'Norpramin',
  'North American Coral Snake Antivenin (Equine)',
  'Northera',
  'Nortrel',
  'Nortrel 7/7/7',
  'NORTRIPTYLINE HCI',
  'Nortriptyline HCL',
  'Nortriptyline Hydrochloride',
  'Norvasc',
  'Norvir',
  'Not applicable',
  'NOURIANZ',
  'Nova Complex HQ',
  'Novarel',
  'NOVOLOG',
  'NovoLog Mix 70/30',
  'NOXAFIL',
  'Noxivent 101',
  'Noxivent 102',
  'NP THYROID',
  'NP Thyroid 120',
  'NP Thyroid 15',
  'NP Thyroid 30',
  'NP Thyroid 60',
  'NP Thyroid 90',
  'Nplate',
  'NRG APF',
  'NRG Hemo-Stat',
  'NUBEQA',
  'Nucala',
  'NuCaraClinPAK',
  'NuCaraRXPAK',
  'Nucynta',
  'NU-DERM BLENDER',
  'NU-DERM CLEAR',
  'NU-DERM SUNFADER',
  'nu-derm system normal-dry',
  'nu-derm system normal-oily',
  'nu-derm travel set normal/dry',
  'NuDermRxPAK 120',
  'NuDermRxPAK 60',
  'NuDiclo SoluPak',
  'NuDiclo TabPak',
  'NuDroxiPAK',
  'NuDroxiPAK DSDR-50',
  'NuDroxiPAK DSDR-75',
  'NuDroxiPAK E-400',
  'NuDroxiPAK I-800',
  'NuDroxiPAK M-15',
  'NuDroxiPAK N-500',
  'NUEDEXTA',
  'NuLev',
  'Nulibry',
  'NULOJIX',
  'NuLYTELY',
  'NuLYTELY With Flavor Packs',
  'NUMBRINO',
  'NUPLAZID',
  'NUPRO 60 Second Fluoride Foam',
  'NUPRO Chlorhexidine Gluconate',
  'Nupro Fluorides',
  'Nupro Fluorides NaF Oral Solution',
  'NURTEC ODT',
  'NuTriaRX CreamPak',
  'NutriLipid I.V. Fat Emulsion',
  'Nutropin AQ NuSpin 10',
  'Nutropin AQ NuSpin 20',
  'Nutropin AQ NuSpin 5',
  'Nuvakaan II',
  'NUVARING',
  'Nuvessa',
  'Nuvigil',
  'NUZYRA',
  'Nyamyc',
  'Nylia 1/35',
  'Nylia 7/7/7',
  'Nymalize',
  'Nymyo',
  'Nystatin',
  'Nystatin and Triamcinolone Acetonide',
  'Nystatin Cream',
  'Nystatin Oral Suspension',
  'Nystatin Topical Powder',
  'Nystop',
  'NYVEPRIA',
  'OBAGI C RX system C CLARIFYING SERUM',
  'OBAGI-C Rx system C-CLARIFYING SERUM NORMAL TO oily',
  'Obagi-C Rx system C-Therapy Night',
  'OBAGI-C RX System NORMAL-DRY',
  'OBAGI-C RX system NORMAL-oily',
  'OBREDON',
  'Ocaliva',
  'Occuloplex G',
  'OCELLA',
  'OCREVUS',
  'OCTREOSCAN',
  'Octreotide',
  'Octreotide Acetate',
  'OCUFLOX',
  'Odactra',
  'ODEFSEY',
  'Odomzo',
  'Ofev',
  'Ofirmev',
  'OFIRMEV (ACETAMINOPHEN)',
  'Ofloxacin',
  'Ofloxacin ophthalmic',
  'Ofloxacin Otic',
  'OGIVRI',
  'OHM Calendula Balancing',
  'OHM Mouthwash',
  'OHM Parasites',
  'OHM Pituitarum Complex',
  'OHM Tonic Syrup',
  'OHM Venous Aid',
  'OHM-CIR',
  'OHM-DREN LFT',
  'OHM-FLU',
  'OHM-INMA',
  'OHM-OST',
  'OHM-PAN',
  'OHM-REN',
  'OHM-RESB',
  'Olanzapine',
  'Olanzapine and Fluoxetine',
  'OLINVYK',
  'OLIVIA QUIDO FIRM and FADE I',
  'OLIVIA QUIDO FIRM and FADE II',
  'OLMESARTAN MEDOXOMIL',
  'olmesartan medoxomil / amlodipine besylate / hydrochlorothiazide',
  'OLMESARTAN MEDOXOMIL AND HYDROCHLOROTHIAZIDE',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide 20/5/12.5 mg',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide 40/10/12.5 mg',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide 40/10/25 mg',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide 40/5/12.5 mg',
  'Olmesartan Medoxomil, Amlodipine and Hydrochlorothiazide 40/5/25 mg',
  'OLMESARTAN MEDOXOMIL/HCTZ',
  'Olopatadine',
  'Olumiant',
  'OLUX',
  'OLUX-E',
  'Omeclamox-Pak',
  'Omega-3-Acid Ethyl Ester',
  'Omega-3-acid ethyl esters',
  'Omegaven',
  'Omeprazole and Sodium Bicrabonate',
  'OMEPRAZOLE DR',
  'omeprazole sodium bicarbonate',
  'Omeprazole, Sodium bicarbonate',
  'Omeprazole/Bicarbonate',
  'Omeprazole/Sodium Bicarbonate',
  'Omidria',
  'Omnaris',
  'OMNIPAQUE',
  'OMNISCAN',
  'Omnitrenidol',
  'Omnitrope',
  'ONCASPAR',
  'Ondansetron',
  'Ondansetron HCL',
  'Ondansetron Hydrochloride',
  'ONEXTON',
  'Onfi',
  'ONGENTYS',
  'ONGLYZA',
  'Onivyde',
  'Onpattro',
  'Ontruzant',
  'ONUREG',
  'Onycho-Med',
  'Onzetra Xsail',
  'OPDIVO',
  'OPDUALAG',
  'Opium Tincture Deodorized',
  'OPSUMIT',
  'Optiray',
  'Optison',
  'OPZELURA',
  'Orabloc',
  'ORACEA',
  'Oracit',
  'Oral B Minute-Foam',
  'Oral B Neutra Foam',
  'Oral B NeutraCare',
  'Oralair',
  'Oralone',
  'Orapred',
  'Oraqix',
  'Oraverse',
  'Oravig',
  'Orbactiv',
  'Orchard Grass, Standardized',
  'ORENCIA',
  'Orenitram',
  'Orfadin',
  'Orgovyx',
  'Oriahnn',
  'Origanum marjorana',
  'Orilissa',
  'ORKAMBI',
  'Orladeyo',
  'Orphenadrine Citrate',
  'Orphenadrine Citrate Aspirin Caffeine',
  'Orphenadrine Citrate, Aspirin and Caffeine',
  'ORPHENGESIC FORTE',
  'Orsythia',
  'Ortho Cyclen',
  'Ortho Tri Cyclen',
  'Ortikos',
  'OSCIMIN',
  'oseltamavir phosphate',
  'OSELTAMIVIR',
  'Oseltamivir Phosphate',
  'Oseltamivir Phosphate for Oral Suspension',
  'OSENI',
  'Osmitrol',
  'Osmolex ER',
  'OsmoPrep',
  'Osphena',
  'Otezla',
  'OTIPRIO',
  'OTOVEL',
  'Otrexup',
  'OVACE',
  'OVACE Plus',
  'OvacePlus',
  'Ovide',
  'Ovidrel',
  'OXACILLIN',
  'Oxaliplatin',
  'Oxandrolone',
  'Oxaprozin',
  'OXAYDO',
  'Oxazepam',
  'OXBRYTA',
  'Oxcarbazepine',
  'OXERVATE',
  'Oxiconazole Nitrate',
  'Oxistat',
  'OXLUMO',
  'OXTELLAR XR',
  'oxybutynin',
  'Oxybutynin Chloride',
  'Oxycodone',
  'OXYCODONE AND ACETAMINOPHEN',
  'OXYCODONE APAP',
  'OXYCODONE HCl',
  'Oxycodone Hydchloride',
  'oxycodone hydrochloride',
  'Oxycodone Hydrochloride and Acetaminophen',
  'Oxycodone Hydrochloride Oral Solution',
  'OXYCODONE/APAP',
  'OxyContin',
  'Oxygen',
  'Oxygen Compressed',
  'Oxygen Compressed Gas',
  'Oxygen Compressed UN 1072 Refrigerated UN 1073',
  'Oxygen Helium Mixture 20/80',
  'Oxygen Helium Mixture 30/70',
  'Oxygen Nitrogen Mixture',
  'Oxygen Refrigerated Liquid',
  'Oxygen Size 400',
  'Oxygen Size B',
  'Oxygen Size C',
  'Oxygen Size D',
  'Oxygen Size E',
  'Oxygen Size F',
  'Oxygen Size H',
  'Oxygen Size M',
  'Oxygen Size T',
  'Oxygen, Compressed U.S.P.',
  'Oxygen, Refrigerated',
  'Oxygen/Helium 20/80',
  'Oxygen/Helium 25/75',
  'Oxygen/Helium 30/70',
  'Oxygen/Helium 40/60',
  'Oxygen/Helium 50/50',
  'Oxymetazoline Hydrochloride',
  'Oxymorphone Hydrochloride',
  'Oxytocin',
  'OXYTROL',
  'Ozempic',
  'OZOBAX',
  'OZURDEX',
  'Pacerone',
  'Paclitaxel',
  'Paclitaxel Protein-Bound Particles for Injectable Suspension (Albumin-Bound)',
  'PADCEV',
  'PALFORZIA',
  'Paliperidone',
  'Pall Sterile Cord Blood Collection Unit',
  'Palonosetron',
  'Palonosetron Hydrochloride',
  'Palynziq',
  'PAMELOR',
  'Pamidronate Disodium',
  'PANCREAZE',
  'Pancuronium Bromide',
  'PANDEL',
  'Panhematin',
  'PANRETIN',
  'Pantoprazole',
  'Pantoprazole Sodium',
  'PANTOPRAZOLE SODIUM D/R',
  'Papaverine Hydrochloride',
  'Para Solve',
  'ParaGard T 380A',
  'PARAPLATIN',
  'Parathyroid',
  'Paremyd',
  'Paricalcitol',
  'Parlodel',
  'PARNATE',
  'PAROEX',
  'Paromomycin Sulfate',
  'Paroxetine',
  'PAROXETINE HYDROCHLORIDE',
  'PARSABIV',
  'Paser',
  'PATANASE',
  'PAXIL',
  'Paxlovid',
  'Pazeo',
  'PCXX ANTICARIES NO FLAVOR NE G',
  'PCXX APF RNS BUBBLEGUM',
  'PCXX APF RNS GRAPE',
  'PCXX APF RNS MINT',
  'PCXX APF RNS STRAWBERRY',
  'PCXX BANANA BERRY APF G',
  'PCXX BUBBLEGUM APF F',
  'PCXX BUBBLEGUM APF G',
  'PCXX BUBBLEGUM NEUTRAL F',
  'PCXX BUGGLEGUM NEUTRAL GL',
  'PCXX CAPPUCCINO APF F',
  'PCXX CHERRY APF F',
  'PCXX CHERRY APF G',
  'PCXX COOL PEPPERMINT APF G',
  'PCXX CREME DE MENTHE APF G',
  'PCXX CREME DE MENTHE NEUTRAL GL',
  'PCXX GRAPE APF F',
  'PCXX GRAPE APF G',
  'PCXX LIME APF F',
  'PCXX MARSHMALLOW APF G',
  'PCXX MOCHA CAPPUCCINO APF G',
  'PCXX MOCHA CAPPUCCINO NEUTRAL GL',
  'PCXX NEUTRAL RMS BUBBLEGUM',
  'PCXX NEUTRAL RNS GRAPE',
  'PCXX NEUTRAL RNS PEPPERMINT',
  'PCXX NEUTRAL RNS WATERMELON',
  'PCXX NO FLAVOR NEUTRAL F',
  'PCXX PEPPERMINT APF F',
  'PCXX PEPPERMINT NEUTRAL F',
  'PCXX PEPPERMINT NEUTRAL GL',
  'PCXX PINA COLADA APF G',
  'PCXX RASPBERRY APF F',
  'PCXX RASPBERRY APF G',
  'PCXX RASPBERRY NEUTRAL GL',
  'PCXX ROOTBEER APF G',
  'PCXX SNF RNS BUBBLEGUM',
  'PCXX SNF RNS GRAPE',
  'PCXX SNF RNS MINT',
  'PCXX SNF RNS STRAWBERRY',
  'PCXX STRAWBERRY APF F',
  'PCXX STRAWBERRY APF G',
  'PCXX STRAWBERRY NEUTRAL F',
  'PCXX VANILLA ORANGE APF G',
  'PCXX VANILLA ORANGE NEUTRAL F',
  'PCXX VANILLA ORANGE NEUTRAL GL',
  'PCXX VANILLA ORANGE ONE MINUTE FM',
  'PCXX WATERMELON APF G',
  'PCXX WATERMELON NEUTRAL GL',
  'PEDIAPRED',
  'PEDIATRIC 8.4% SODIUM BICARBONATE',
  'Pediatric Infuvite Multiple Vitamins',
  'PEDIATRIC INFUVITE MULTIPLE VITAMINS FOR INFUSION',
  'PedizolPAK',
  'PEG-3350 and Electrolytes',
  'PEG-3350, Electrolytes, and Ascorbate',
  'PEG-3350, sodium chloride, sodium bicarbonate and potassium chloride',
  'PEG-3350, SODIUM SULFATE, SODIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ASCORBATE AND ASCORBIC ACID',
  'Peganone',
  'Pegasys',
  'PEMAZYRE',
  'Pemfexy',
  'penicillamine',
  'PENICILLIN G POTASSIUM',
  'PENICILLIN G PROCAINE',
  'Penicillin G Sodium',
  'Penicillin V Potasium',
  'Penicillin V Potassium',
  'Pennsaicin',
  'Pennsaid',
  'Pentam 300',
  'Pentamidine Isethionate',
  'Pentasa',
  'Pentazocine and naloxone',
  'PENTAZOCINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE',
  'Pentetate calcium trisodium',
  'Pentetate zinc trisodium',
  'Pentobarbital Sodium',
  'PENTOXIFYLLINE',
  'Pepaxto',
  'Pepcid',
  'PERCOCET',
  'Perforomist',
  'Peridex',
  'Perikabiven',
  'Perindopril Erbumine',
  'PerioChip',
  'Periogard (Chlorhexidine Gluconate)',
  'Periogard Alcohol Free',
  'PERJETA',
  'Permethrin',
  'Perphenazine',
  'Perphenazine and Amitriptyline Hydrochloride',
  'PERSERIS',
  'Pertussinum',
  'PERTZYE',
  'Petroselinum sativum',
  'PEXEVA',
  'Pfizerpen',
  'PharmapureRx Lidocaine HCl 4.12%',
  'PHENADOZ',
  'PHENAZOPYRIDINE',
  'Phenazopyridine HCl 100mg',
  'Phenazopyridine HCl 200mg',
  'Phenazopyridine Hydrochloride',
  'Phendimetrazine',
  'Phendimetrazine Tartrate',
  'Phenelzine Sulfate',
  'PHENERGAN',
  'Phenobarbital',
  'Phenobarbital Oral Solution',
  'Phenobarbital Sodium',
  'Phenobarbital with Belladonna Alkaloids',
  'Phenobarbital with Belladonna Alkaloids - Grape',
  'Phenobarbital with Belladonna Alkaloids - Mint',
  'Phenobarbital, Hyoscyamine Sulfate, Atropine Sulfate and Scopolamine Hydrobromide',
  'Phenobarbital, Hyoscyamine Sulfate, Atropine Sulfate, Scopolamine Hydrobromide',
  'Phenohytro',
  'Phenoxybenzamine Hydrochloride',
  'Phentermine',
  'PHENTERMINE HCL',
  'PHENTERMINE HCL C-IV',
  'phentermine hydrochloride',
  'Phentolamine Mesylate',
  'PHENYLEPHRINE HCI',
  'Phenylephrine Hydrochloride',
  'Phenytek',
  'Phenytoin',
  'Phenytoin Infatabs',
  'Phenytoin Sodium',
  'Phesgo',
  'Phexxi',
  'Philith',
  'PhosLo',
  'Phoslyra',
  'Phosphasal',
  'Phospholine Iodide',
  'Photofrin',
  'Photrexa',
  'Photrexa Cross-linking Kit',
  'Photrexa Viscous',
  'PHOXILLUM',
  'Physician EZ Use Joint Tunnel and Trigger Kit',
  'Physician EZ Use Joint Tunnel and Trigger Kit II',
  'Physicians EZ Use B-12 Compliance',
  'Physicians EZ Use M-pred',
  'Physiolyte',
  'Physiosol',
  'PHYSOSTIGMINE SALICYLATE',
  'PHYTONADIONE',
  'Picato',
  'PIFELTRO',
  'pilocarpine hydrchloride',
  'Pilocarpine Hydrochloride',
  'pimecrolimus',
  'Pimozide',
  'PIMTREA',
  'Pindolol',
  'PINPOINT Lymphatics Kit',
  'Pioglitazole and metformin hydrochloride',
  'Pioglitazone',
  'pioglitazone and glimepiride',
  'Pioglitazone and metformin',
  'Pioglitazone Hydrochloride',
  'Pioglitazone hydrochloride and glimepiride',
  'Pioglitazone Hydrochloride and Metformin Hydrochloride',
  'PIOGLITAZONEHYDROCHLORIDE',
  'Piperacillin and Tazobactam',
  'PIPERACILLIN SODIUM and TAZOBACTAM SODIUM',
  'Piperacillin, Tazobactam',
  'PIQRAY',
  'Pirfenidone',
  'PIRMELLA 1/35',
  'PIRMELLA 7/7/7',
  'Pirnuo',
  'Piroxicam',
  'Pitocin',
  'Pituitarum posterium',
  'PIZENSY',
  'Plaquenil',
  'Plasma-Lyte 148',
  'Plasma-Lyte A',
  'Plavix',
  'Plegisol',
  'Plegridy',
  'Plenamine',
  'Plenvu',
  'Plexion',
  'PLEXION NS',
  'PLIAGLIS',
  'PLUVICTO',
  'PNV-DHA',
  'PNV-Omega',
  'PNV-Select',
  'Podocon 25',
  'PODOFILOX',
  'Point Of Care Kit KM',
  'Point Of Care L2',
  'Point Of Care L5',
  'Point Of Care LM 2.2',
  'Point Of Care LM 2.5',
  'Point Of Care LM DEP 2',
  'POLIVY',
  'Pollens - Weeds and Garden Plants, Ragweed, Mixed Ambrosia',
  'Pollens - Weeds and Garden Plants, Short Ragweed, Ambrosia artemisiifolia',
  'POLMON',
  'Polocaine',
  'POLOCAINE (MEPIVACAINE HCl)',
  'POLOCAINE(R) -MPF (MEPIVACAINE HCI)',
  'Polocaine-MPF',
  'polycin',
  'Polyethylene Glycol 3350 and electrolytes - Unflavored',
  'Polyethylene Glycol 3350 and electrolytes with Lemon Flavor',
  'Polyethylene Glycol 3350 and electrolyteswith Orange Flavor',
  'Polyethylene Glycol 3350, Sodium Chloride, Sodium Bicarbonate and Potassium Chloride - Unflavored',
  'Polyethylene Glycol 3350, Sodium Chloride, Sodium Bicarbonate and Potassium Chloride with Lemon Flavor',
  'Polyethylene Glycol 3350, Sodium Chloride, Sodium Bicarbonate and Potassium Chloride with Orange Flavor',
  'POLYETHYLENE GLYCOL-3350 AND ELECTROLYTES',
  'Polymyxin B',
  'POLYMYXIN B SULFATE AND TRIMETHOPRIM',
  'POLYMYXIN B SULFATE and TRIMETHOPRIM SULFATE',
  'Polytrim',
  'Pomalyst',
  'PONVORY',
  'Portia',
  'Portrazza',
  'POSACONAZOLE',
  'Positive Skin Test Control - Histamine',
  'Potassium Acetate',
  'Potassium Chloride',
  'Potassium chloride extended release',
  'Potassium Chloride Extended-release',
  'Potassium Chloride for Oral Solution',
  'POTASSIUM CHLORIDE IN DEXTROSE',
  'Potassium Chloride in Dextrose and Sodium Chloride',
  'Potassium Chloride in Lactated Ringers and Dextrose',
  'POTASSIUM CHLORIDE IN SODIUM CHLORIDE',
  'Potassium Citrate',
  'Potassium Citrate and Citric Acid',
  'Potassium Citrate, Sodium Citrate, and Citric Acid',
  'Potassium Phosphates',
  'Potassium-cit',
  'POTELIGEO',
  'Pradaxa',
  'Praluent',
  'PRAMIPEXOLE',
  'Pramipexole Dihydrochloride',
  'Pramosone',
  'Pramosone Cream',
  'Prandin',
  'Prasugrel',
  'Pravastatin Sodium',
  'Praxbind',
  'PRAZIQUANTEL',
  'Prazosin',
  'Prazosin Hydrochloride',
  'Pre and Post Sx Pouch',
  'PRECEDEX',
  'PRED FORTE',
  'PRED MILD',
  'PRED-G',
  'Prednicarbate',
  'PrednisoLONE',
  'Prednisolone Acetate',
  'Prednisolone Sodium Phosphate',
  'Prednisolone Sodium Phosphate Oral Solution',
  'PredniSONE',
  'PredniSONE Intensol',
  'Prefest',
  'Pregabalin',
  'PREGABALIN capsules, CV',
  'Pregabalin Extended Release',
  'Pregnyl',
  'Prelidopine Pre-Operative System',
  'Premarin',
  'Premasol - sulfite-free (Amino Acid)',
  'Premphase',
  'Prempro',
  'Prenaissance',
  'Prenaissance Plus',
  'PRENATAL PLUS',
  'Prenatal Plus Vitamins',
  'Prenatal Vitamins Plus',
  'Prenatal Vitamins Plus Low Iron',
  'Prenate Chewable',
  'PRENATE DHA',
  'Prenate Elite',
  'PRENATE Enhance',
  'Prenate Essential',
  'Prenate Mini',
  'Prenate Pixie',
  'PRENATE Restore',
  'Prenatrix',
  'Prenatryl',
  'PRE-PEN',
  'Prepidil',
  'Prestalia',
  'Pretomanid',
  'Pretrate',
  'Prevacid SoluTab',
  'Prevalite',
  'PrevidDent 5000 Booster Plus Spearmint',
  'PreviDent',
  'PreviDent 5000 Booster Plus Fruitastic',
  'PreviDent 5000 Enamel Protect',
  'PreviDent Alcohol Free',
  'PreviDent Fresh Mint',
  'PreviDent OrthoDefense',
  'PreviDent Very Berry',
  'Previfem',
  'PREVYMIS',
  'PREZCOBIX',
  'PREZISTA',
  'Prialt',
  'Priftin',
  'Prilo Patch',
  'Prilo Patch-II',
  'PRILOHEAL PLUS 30',
  'Prilosec',
  'PRILOVIX Lite',
  'PRILOVIX Lite Plus',
  'PRILOVIX UltraLite',
  'PRILOVIX Ultralite Plus',
  'PRILOVIXIL',
  'Primaquine Phosphate',
  'PRIMAXIN',
  'Primidone',
  'Primo APF',
  'PRISMASOL',
  'Pristiq',
  'Prizopak II',
  'Prizotral II',
  'PROAIR',
  'ProAir Digihaler',
  'ProAir RespiClick',
  'Probenecid',
  'Probenecid and Colchicine',
  'PROCAINAMIDE HCI',
  'PROCAINAMIDE HYDROCHLORIDE',
  'ProcalAmine',
  'Procardia',
  'Pro-C-Dure 5 Kit',
  'Pro-C-Dure 6 Kit',
  'Procentra',
  'Prochlorperazine',
  'Prochlorperazine Edisylate',
  'Prochlorperazine Maleate',
  'PROCORT',
  'PROCRIT',
  'Proctocort',
  'PROCTOFOAM',
  'Procto-Med HC',
  'Proctosol-HC',
  'Proctozone',
  'PROCTOZONE-HC',
  'PROCYSBI',
  'Profinac',
  'Progesterone',
  'Proglycem',
  'Prograf',
  'ProHance',
  'Prolate',
  'Prolensa',
  'Proleukin',
  'Prolia',
  'PROMACTA',
  'Prometa',
  'Promethazine',
  'PROMETHAZINE DM',
  'PROMETHAZINE HCI',
  'Promethazine HCl, Phenylephrine HCl, Codeine Phosphate',
  'Promethazine Hydrochloride',
  'promethazine hydrochloride and codeine phosphate',
  'Promethazine Hydrochloride and Dextromethophan Hydrobromide',
  'Promethazine Hydrochloride and Dextromethorphan Hydrobromide',
  'Promethazine Hydrochloride and Dextromethorphan Hydrobromide Oral',
  'Promethazine Hydrochloride and Dextromethorphan Hydrobromide Oral Solution',
  'Promethazine Hydrochloride and Phenylephrine Hydrochloride',
  'promethazine hydrochloride, phenylephrine hydrochloride and codeine phosphate',
  'Promethazine VC',
  'Promethazine VC with Codeine Oral Solution',
  'Promethazine with Codeine',
  'PROMETHEGAN',
  'Prometrium',
  'Propafenone HCl',
  'Propafenone Hydrochloride',
  'Propantheline Bromide',
  'Proparacaine Hydrochloride',
  'PROPECIA',
  'Propofol',
  'Propofol Injectable Emulsion',
  'Propofol Lipuro',
  'Propranolol',
  'Propranolol hcl ER',
  'Propranolol Hydrochloride',
  'PROPRANOLOL HYDROCHLORIDE ER',
  'Propylthiouracil',
  'PROSCAR',
  'ProSol',
  'PROSTIN',
  'PROTAMINE SULFATE',
  'Proteus',
  'Protherix',
  'Protonix',
  'Protopam Chloride',
  'Protopic',
  'Protriptyline Hydrochloride',
  'PROVAYBLUE',
  'Proventil HFA',
  'Provera',
  'Provigil',
  'Provocholine',
  'Provocholine Inhalation Solution',
  'Prozac',
  'PRUDOXIN',
  'Prunus spinosa',
  'PRYIDOSTIGMINE BROMIDE',
  'PS1 Aciurgy Pack',
  'PS2 Aciurgy Pack',
  'psorcon',
  'Psorinum',
  'Psorizide Forte',
  'Psorizide Ultra',
  'PULMICORT',
  'PULMICORT RESPULES',
  'Pulmotech MAA',
  'Pulmozyme',
  'PureLife APF',
  'PureVit DualFe Plus',
  'Purified Cortrophin Gel',
  'PURINETHOL',
  'PURIXAN',
  'PYLARIFY',
  'Pylera',
  'Pyrazinamide',
  'Pyridium',
  'Pyridostigmine',
  'Pyridostigmine Bromide',
  'PYRIDOXINE HCI',
  'Pyridoxine Hydrochloride',
  'Pyrimethamine',
  'Pyrukynd',
  'Qbrelis',
  'Qbrexza',
  'QDOLO',
  'QELBREE',
  'QINLOCK',
  'QKit Procedure Tray',
  'QNASL',
  'Qsymia',
  'QTERN',
  'Qualaquin',
  'QUARTETTE',
  'Quazepam',
  'QUDEXY',
  'QUELICIN',
  'QUESTRAN',
  'Quetiapine',
  'Quetiapine Fumarate',
  'Quflora FE Pediatric Drops',
  'Quflora Pediatric',
  'Quflora Pediatric Drops',
  'QuilliChew ER',
  'Quillivant',
  'QUINAPRIL',
  'quinapril and hydrochlorothiazide',
  'Quinapril and Hydrochlorothiazide 10/12.5',
  'Quinapril and Hydrochlorothiazide 20/12.5',
  'Quinapril and Hydrochlorothiazide 20/25',
  'Quinapril HCL and Hydrochlorothiazide',
  'quinapril hydrochloride and hydrochlorothiazide',
  'QUINAPRIL HYDROCHLORIDE/HYDROCHLOROTHIAZIDE',
  'Quinidine Gluconate',
  'Quinidine Sulfate',
  'Quinine Sulfate',
  'Quinixil',
  'Qulipta',
  'Qutenza',
  'QUZYTTIR',
  'QVAR REDIHALER',
  'Qwo',
  'Rabeprazole sodium',
  'RABERPRAZOLE SODIUM D/R',
  'Radiaura Skin Recovery',
  'RADICAVA',
  'Radiogardase',
  'RadioGenix System',
  'RAGWITEK',
  'Raloxifene Hydrochloride',
  'Ramelteon',
  'Ramipril',
  'Ranexa',
  'Ranitidine',
  'Ranitidine Hydrochloride',
  'Ranolazine',
  'RAPAFLO',
  'Rapamune',
  'Rapivab',
  'Rasagiline',
  'Rasagiline Mesylate',
  'Rasuvo',
  'Ravicti',
  'Raxibacumab',
  'Rayaldee',
  'RAYOS',
  'RAZADYNE',
  'Readi-Cat 2',
  'Readi-Cat 2 Banana Smoothie',
  'Readi-Cat 2 Berry Smoothie',
  'Readi-Cat 2 Creamy Vanilla Smoothie',
  'Readi-Cat 2 Mochaccino Smoothie',
  'ReadySharp Betamethasone',
  'ReadySharp Dexamethasone',
  'ReadySharp Lidocaine',
  'REALHEAL-I',
  'REBETOL',
  'REBIF',
  'REBIF REBIDOSE',
  'REBINYN',
  'Reblozyl',
  'RECARBRIO',
  'Reclast',
  'Reclipsen',
  'reconstituted Air',
  'Recorlev',
  'RECOTHROM',
  'Recovatone',
  'Rectiv',
  'RediTrex',
  'Redtop Grass, Standardized',
  'REGEN-COV',
  'REGIOCIT',
  'Reglan',
  'Regonol',
  'REGRANEX',
  'Rejuvesol',
  'RELAFEN',
  'RELAFEN DS',
  'RELENZA',
  'RELEUKO',
  'RELEXXII',
  'Relistor',
  'Relpax',
  'Reltone 200 mg',
  'Reltone 400 mg',
  'REMERON',
  'REMERONSOLTAB',
  'REMICADE',
  'REMIFENTANIL HYDROCHLORIDE',
  'Remodulin',
  'Renacidin',
  'Renagel',
  'Renflexis',
  'Renova',
  'Renvela',
  'Repaglinide',
  'REPATHA',
  'Respiratory Plus',
  'RESTASIS',
  'Restasis MultiDose',
  'RESTORIL',
  'RETACRIT',
  'Retavase',
  'RETEVMO',
  'RETHYMIC',
  'Retin-A',
  'Retin-A MICRO',
  'Retisert',
  'RETROVIR',
  'Revatio',
  'Revcovi',
  'Revlimid',
  'Revonto',
  'Rexulti',
  'REYATAZ',
  'Reyvow',
  'REZIPRES',
  'Rezurock',
  'Rezvoglar',
  'R-Gene',
  'Rheumatism',
  'RHOFADE',
  'Rhopressa',
  'Riabni',
  'Ribavirin',
  'Ribotin-E',
  'RIDAURA',
  'Rifabutin',
  'Rifadin IV',
  'Rifadin IV NOVAPLUS',
  'Rifampin',
  'Rilutek',
  'Riluzole',
  'Rimantadine Hydrochloride',
  'RIMSO-50',
  'Ringers',
  'Ringers Irrigation',
  'Rinvoq',
  'Riomet',
  'Risedronate Sodium',
  'RISPERDAL',
  'RISPERDAL CONSTA',
  'RISPERDAL M-TAB',
  'Risperidone',
  'Ritalin',
  'Ritonavir',
  'Rituxan',
  'Rituxan Hycela',
  'Rivastigmine',
  'Rivastigmine Tartrate',
  'Rivastigmine Transdermal System',
  'Rivelsa',
  'Rizatriptan',
  'Rizatriptan Benzoate',
  'Rizatriptan Benzoate ODT',
  'ROBAXIN',
  'Robinul',
  'Robinul Forte',
  'Rocaltrol',
  'Rocklatan',
  'Rocuronium',
  'Rocuronium Bromide',
  'Romidepsin',
  'Ropidex',
  'Ropinirole',
  'ROPINIROLE HYDROCHLORIDE',
  'Ropivacaine Hydrochloride',
  'Rosadan',
  'Rosuvastatin',
  'ROSUVASTATIN AND EZETIMIBE',
  'Rosuvastatin calcium',
  'ROSZET',
  'ROTOP - DMSA',
  'Rowasa',
  'Roweepra',
  'Roxicodone',
  'Rozerem',
  'Rozlytrek',
  'Rubraca',
  'RUBY-FILL',
  'Ruconest',
  'Rufinamide',
  'Rukobia',
  'Ruxience',
  'RYANODEX',
  'RYBELSUS',
  'Rybrevant',
  'RYCLORA',
  'RYDAPT',
  'Rye Grass, Perennial Standardized',
  'Rylaze',
  'RYTARY',
  'RYTHMOL',
  'RyVent',
  'SABRIL',
  'Safyral',
  'Saizen',
  'saizenprep',
  'SAJAZIR',
  'Salagen',
  'Salex',
  'Salicylic Acid 6 percent',
  'Salinocaine',
  'Salsalate',
  'Salvax',
  'SAMSCA',
  'SANCUSO',
  'Sandimmune',
  'Sandostatin',
  'Sandostatin LAR Depot',
  'SAPHNELO',
  'SAPHRIS',
  'Sapropterin Dihydrochloride',
  'Sarclisa',
  'SAVAYSA',
  'Savella',
  'Saxenda',
  'Scandonest 2% L',
  'Scandonest 3% Plain',
  'Scars-Adhesions',
  'SCEMBLIX',
  'SCENESSE',
  'Scopolamine',
  'Scopolamine Trandermal System',
  'Seasonique',
  'SECUADO',
  'SEGLENTIS',
  'SEGLUROMET',
  'Seizalam',
  'Select-OB Plus DHA',
  'Selegiline Hydrochloride',
  'Selenious Acid',
  'Selenium Sulfide',
  'SELZENTRY',
  'SEMGLEE',
  'Sensipar',
  'Sensorcaine',
  'Sensorcaine MPF',
  'SENSORCAINE(R) (BUPIVACAINE HCI AND EPINEPHRINE)',
  'Septocaine and Epinephrine',
  'SEREVENT',
  'Sernivo',
  'SEROMYCIN',
  'SEROQUEL',
  'Serostim',
  'Sertraline',
  'sertraline HCl',
  'Sertraline Hydrochloride',
  'SETLAKIN',
  'sevelamer carbonate',
  'Sevelamer Carbonate for Oral Suspension',
  'Sevelamer Hydrochloride',
  'Sevenfact',
  'Sevoflurane',
  'Seysara',
  'SF',
  'SF 5000 Plus',
  'sfRowasa',
  'SHAROBEL',
  'Signifor',
  'Signifor LAR',
  'Siklos',
  'Sila III',
  'Sildenafil',
  'SILDENAFIL CITRATE',
  'Sildenafil for Oral Suspension',
  'Silenor',
  'Siliq',
  'Silodosin',
  'SILVADENE',
  'Silver Nitrate',
  'Silver Nitrate Applicators',
  'SILVER NITRATE POTASSIUM NITRATE',
  'Silver Sulfadiazine',
  'SIMBRINZA',
  'SIMLIYA',
  'Simpesse',
  'Simponi',
  'SIMPONI ARIA',
  'Simulect',
  'SIMVASTATIN',
  'SINEMET',
  'SINGULAIR',
  'Sinuva',
  'sirolimus',
  'SIRTURO',
  'Sitavig',
  'SIVEXTRO',
  'SKELAXIN',
  'Skin Lightener',
  'Sky Oral Rinse',
  'SkyaDerm-LP',
  'Skyla',
  'Skyrizi',
  'Skytrofa',
  'SleepEase',
  'SLYND',
  'Smoflipid',
  'SOAANZ',
  'Sodium Acetate',
  'SODIUM CHLORIDE',
  'Sodium Chloride for Irrigation',
  'Sodium Citrate 4% w/v Anticoagulant',
  'Sodium Citrate and Citric Acid',
  'Sodium Citrate Blood',
  'Sodium Citrate Blood-Pack Units, (PL 146 Plastic)',
  'Sodium Citrate w/v Anticoagulant',
  'Sodium Diuril',
  'SODIUM EDECRIN',
  'Sodium Ferric Gluconate Complex in Sucrose',
  'Sodium Flouride',
  'Sodium Fluoride',
  'Sodium Fluoride 1.1%',
  'Sodium Fluoride 1.1% Gel',
  'Sodium Fluoride 5000 Plus',
  'Sodium Fluoride 5000 ppm',
  'Sodium Fluoride 5000 ppm Dry Mouth',
  'Sodium Fluoride 5000 ppm Enamel Protect',
  'Sodium Fluoride 5000 ppm Fruit',
  'Sodium Fluoride 5000 ppm Sensitive',
  'Sodium Fluoride 5000 ppm Spearmint',
  'Sodium Fluoride Chewable',
  'Sodium Fluoride F 18',
  'Sodium Iodide I 123',
  'Sodium Iodide I 131 Diagnostic',
  'Sodium Iodide I-131',
  'Sodium Nitrite',
  'sodium nitroprusside',
  'SODIUM PHENYLACETATE and SODIUM BENZOATE',
  'Sodium Phenylbutyrate',
  'Sodium Phosphates',
  'Sodium Polystyrene Sulfonate',
  'Sodium Sulfacetamide',
  'SODIUM SULFACETAMIDE - SULFUR CLEANSING PADS',
  'SODIUM SULFACETAMIDE - SULFUR WASH',
  'Sodium Sulfacetamide 10 Sulfur 2 Cleanser',
  'Sodium Sulfacetamide 10 Sulfur 2 cream',
  'Sodium Sulfacetamide 10 Sulfur 5 Cleanser',
  'Sodium Sulfacetamide 10% and Sulfur 2% Cleanser',
  'Sodium Sulfacetamide 10% and Sulfur 5% Cleanser',
  'Sodium Sulfacetamide 10% and Sulfur 5% Emollient Foam',
  'Sodium Sulfacetamide 10%, Sulfur 2%',
  'Sodium Sulfacetamide 8% and Sulfur 4%',
  'Sodium Sulfacetamide 8% and Sulfur 4% Cleanser',
  'Sodium Sulfacetamide 9 Sulfur 4.5 Wash',
  'Sodium Sulfacetamide 9% - Sulfur 4%',
  'Sodium Sulfacetamide 9% - Sulfur 4.5% Wash',
  'Sodium Sulfacetamide 9% and Sulfur 4% Cleanser',
  'Sodium Sulfacetamide 9.8% and Sulfur 4.8%',
  'Sodium Sulfacetamide 9.8% and Sulfur 4.8% Cleanser',
  'Sodium Sulfacetamide 9.8% and Sulfur 4.8% Cream',
  'Sodium Sulfacetamide 9.8%, Sulfur 4.8%',
  'SODIUM SULFACETAMIDE and SULFUR',
  'Sodium Sulfacetamide and Sulfur Cleanser',
  'SODIUM SULFACETAMIDE, SULFUR',
  'SODIUM SULFATE, POTASSIUM SULFATE, MAGNESIUM SULFATE',
  'Sodium Tetradecyl Sulfate',
  'Sodium Thiosulfate',
  'Sodum Acetate',
  'Sofosbuvir and Velpatasvir',
  'Sojourn',
  'Solaravix',
  'Solaraze',
  'Solifenacin',
  'Solifenacin succinate',
  'SOLIFENACINE SUCCINATE',
  'Soliqua 100/33',
  'SOLIRIS',
  'Solodyn',
  'SOLOSEC',
  'SOLTAMOX',
  'Solucion InterSol',
  'Solu-Cortef',
  'SOLU-MEDROL',
  'SOLU-MEDROL(R) METHYLPREDNISOLONE SODIUM SUCCINAT',
  'Soma',
  'SOMATULINE DEPOT',
  'SOMAVERT',
  'SOOLANTRA',
  'Sorafenib Tosylate',
  'Sorbet APF',
  'Sorbitol',
  'Sorbitol-Mannitol',
  'SORIATANE',
  'SORILUX',
  'Sorine',
  'Sotalol',
  'Sotalol Hydrochloride',
  'Sotradecol',
  'SOTRADECOL (SODIUM TETRADECYL SULFATE)',
  'Sotrovimab',
  'SOTYLIZE',
  'Southern Medical Oxygen, Compressed',
  'Sovaldi',
  'Spascupreel',
  'speedgel rx',
  'Spinosad',
  'Spinraza',
  'Spiriva',
  'Spiriva Respimat',
  'Spironolactone',
  'Spironolactone and Hydrochlorothiazide',
  'Spongilla lacustris MT',
  'SPORANOX',
  'Spotex',
  'Spravato',
  'Sprintec',
  'Spritam',
  'Sprix',
  'SPRYCEL',
  'SPY Elite Kit',
  'SPY Lymphatics Kit',
  'SPY-MIS Kit',
  'SPY-PHI Kit',
  'SRONYX',
  'SSD Cream',
  'SSKI',
  'SSS cleanser',
  'Stalevo',
  'Standardized Bermuda Grass',
  'Standardized Bermuda Grass Pollen',
  'Standardized Cat Hair',
  'Standardized Cat Hair Allergenic Extract',
  'Standardized Cat Pelt',
  'Standardized Grass Pollen, Bermuda Grass',
  'Standardized Grass Pollen, Bluegrass, Kentucky June',
  'Standardized Grass Pollen, Fescue, Meadow',
  'Standardized Grass Pollen, Grass Mix 4',
  'Standardized Grass Pollen, Orchard Grass',
  'Standardized Grass Pollen, Redtop',
  'Standardized Grass Pollen, Ryegrass',
  'Standardized Grass Pollen, Sweet Vernal Grass',
  'Standardized Grass Pollen, Timothy',
  'Standardized Kentucky (June) Bluegrass Pollen',
  'Standardized Kentucky Blue (June) Grass',
  'Standardized Meadow Fescue Grass',
  'Standardized Meadow Fescue Pollen',
  'Standardized Mite D. farinae',
  'Standardized Mite D. pteronyssinus',
  'Standardized Mite Dermatophagoides farinae',
  'Standardized Mite Dermatophagoides pteronyssinus',
  'Standardized Mite Mix Dermatophagoides farinae and Dermatophagoides pteronyssinus',
  'Standardized Mite Mix, Dermatophagoides pteronyssinus and Dermatophagoides farinae, 10000 AU per mL',
  'Standardized Mite Mix, Dermatophagoides pteronyssinus and Dermatophagoides farinae, 30000 AU per mL',
  'Standardized Mite, Dermatophagoides farinae, Bulk, 10000 AU per mL',
  'Standardized Mite, Dermatophagoides farinae, Scratch or Bulk, 30000 AU per mL',
  'Standardized Mite, Dermatophagoides pteronyssinus, Bulk, 10000 AU per mL',
  'Standardized Mite, Dermatophagoides pteronyssinus, Scratch or Bulk, 30000 AU per mL',
  'Standardized Mite, Mixed',
  'Standardized Orchard Grass',
  'Standardized Orchard Grass Pollen',
  'Standardized Perennial Rye Grass',
  'STANDARDIZED PERENNIAL RYE GRASS POLLEN',
  'Standardized Perennial Ryegrass Pollen',
  'Standardized Redtop Grass',
  'Standardized Redtop Pollen',
  'Standardized Sweet Vernal Grass',
  'Standardized Sweet Vernal Grass Pollen',
  'Standardized Timothy Grass',
  'Standardized Timothy Pollen',
  'Staphylococcinum',
  'stavudine',
  'STEGLATRO',
  'STEGLUJAN',
  'Stelara',
  'Stendra',
  'Sterile Cord Blood Collection Unit (MSC127D)',
  'Sterile Cord Blood Collection Unit (MSC128D)',
  'Sterile Diluent for Remodulin',
  'Sterile Water',
  'Steritalc',
  'Stimate',
  'Stiolto Respimat',
  'Stiptik',
  'Stivarga',
  'StrataGraft',
  'Strattera',
  'STRENSIQ',
  'Streptococcinum',
  'Streptomycin',
  'Stribild',
  'Striverdi Respimat',
  'STROMECTOL',
  'Strong Iodine Solution',
  'STRONTIUM CHLORIDE Sr-89',
  'Strophanthus hispidus',
  'Strovite One',
  'STYPTSTIX',
  'SUBLOCADE',
  'Suboxone',
  'SUBSYS',
  'SUBVENITE',
  'Succinylcholine',
  'Succinylcholine Chloride',
  'Sucraid',
  'Sucralfate',
  'Sufentanil Citrate',
  'Sular',
  'Sulconazole Nitrate',
  'sulfacetamide',
  'Sulfacetamide Sodium',
  'Sulfacetamide Sodium and Prednisolone Sodium Phosphate',
  'Sulfacetamide Sodium and Sulfur',
  'SULFACETAMIDE SODIUM, SULFUR',
  'SulfaCleanse 8/4',
  'Sulfadiazine',
  'SULFAMETH/TRIMETH-DS',
  'Sulfamethoxazole and Trimethoprim',
  'Sulfamethox-TMP DS',
  'SULFAMYLON',
  'Sulfasalazine',
  'SULFATRIM',
  'Sulindac',
  'Sumadan',
  'Sumadan Wash',
  'Sumansetron',
  'Sumatriptan',
  'Sumatriptan and Naproxen Sodium',
  'Sumatriptan Succinate',
  'Sumatriptan Succinate and Naproxen Sodium',
  'Sumaxin',
  'Sumaxin CP',
  'SUMYCIN',
  'Sunitinib Malate',
  'SUNLINDAC',
  'SUNOSI',
  'SUPPRELIN',
  'Suprane',
  'SUPRAX',
  'SUPREP Bowel Prep',
  'Survanta',
  'SUSTIVA',
  'SUSTOL',
  'Susvimo',
  'SUTAB',
  'SUTENT',
  'Swabs',
  'Sweet Vernal Grass, Standardized',
  'Sx1 Medicated Post-Operative System',
  'Syeda',
  'Sylvant',
  'Symax Duotab',
  'Symax SL',
  'Symax SR',
  'SYMBICORT',
  'Symbyax',
  'SYMDEKO',
  'SYMFI',
  'SYMFI LO',
  'Symjepi',
  'SymlinPen',
  'SYMPAZAN',
  'SYMPROIC',
  'Symtuza',
  'Synagis',
  'Synalar',
  'Synalar TS',
  'Synarel',
  'SYNDROS',
  'Synera',
  'Synercid',
  'Synjardy',
  'SYNRIBO',
  'Synthroid',
  'Syphilinum',
  'Syprine',
  'Systemic Drainage',
  'Syzygium jambolanum',
  'T.R.U.E. Test',
  'TABLOID',
  'TABRECTA',
  'TachoSil',
  'Taclonex',
  'Tacrolimus',
  'Tacrus',
  'Tadalafil',
  'Tafinlar',
  'Tagitol V',
  'TAGRISSO',
  'TAKHZYRO',
  'Talicia',
  'TALTZ',
  'Talzenna',
  'Tamiflu',
  'Tamoxifen Citrate',
  'Tamsulosin hydrochloride',
  'TaperDex 12-day',
  'TaperDex 6-day',
  'TaperDex 7-day',
  'TARCEVA',
  'TARGADOX',
  'Targretin',
  'TARINA 24 FE',
  'TARINA Fe 1/20',
  'Tarina Fe 1/20 EQ',
  'Tarpeyo',
  'Tasigna',
  'Tasmar',
  'Tasoprol',
  'TAUVID',
  'Tavaborole',
  'TAVALISSE',
  'TAVNEOS',
  'TAYSOFY',
  'Taytulla',
  'Tazarotene',
  'TAZICEF',
  'TAZORAC',
  'TAZTIA',
  'TAZVERIK',
  'TECENTRIQ',
  'TECFIDERA',
  'TechneLite',
  'Technescan HDP',
  'Technescan MAG3',
  'Technescan PYP',
  'Technetium Tc 99m Medronate',
  'TECHNETIUM TC 99M SESTAMIBI',
  'Teflaro',
  'Tegretol',
  'Tegsedi',
  'Tekturna',
  'Tekturna HCT',
  'Telmisartan',
  'Telmisartan and Amlodipine',
  'telmisartan and hydrochlorothiazide',
  'telmisartan and hydrochlorthiazide',
  'Temazepam',
  'TEMIXYS',
  'TEMODAR',
  'Temovate',
  'Temozolomide',
  'Temsirolimus',
  'Tencon',
  'Tenofovir Disoproxil Fumarate',
  'tenofovir disproxil fumarate',
  'TENORETIC',
  'TENORMIN',
  'TEPADINA',
  'TEPEZZA',
  'TEPMETKO',
  'terazosin',
  'Terazosin Hydrochloride',
  'Terbinafine',
  'TERBUTALINE SULFATE',
  'Terconazole',
  'Teriflunomide',
  'teriparatide',
  'Terrell',
  'TERUFLEX Blood Bag System Anticoagulant Citrate Phosphate Dextrose (CPD) AND OPTISOL Red Cell Preservative',
  'TERUFLEX Blood Bag System Anticoagulant Citrate Phosphate Dextrose Adenine (CPDA-1)',
  'TERUFLEX Blood Bag System with Blood Sampling Arm Anticoagulant Citrate Phosphate Dextrose (CPD) AND OPTISOL (AS-5) Red Cell Preservative',
  'TERUFLEX Blood Bag System with Diversion Blood Sampling Arm Anticoagulant Citrate Phosphate Dextrose (CPD) AND OPTISOL (AS-5) Red Cell Preservative',
  'Tessalon',
  'Testim',
  'Testone CIK',
  'Testopel',
  'Testosterone',
  'Testosterone Cypionate',
  'TESTOSTERONE ENANTHATE',
  'Testosterone Gel, 1%',
  'Testozole',
  'Tetrabenazine',
  'Tetracaine',
  'Tetracaine HCL',
  'Tetracaine Hydrochloride',
  'Tetracycline Hydrochloride',
  'Texacort',
  'TEZSPIRE',
  'Thalitone',
  'Thallium metallicum',
  'Thallous Chloride Tl 201',
  'Thalomid',
  'THAM',
  'Theo-24',
  'THEOPHYLLINE',
  'Theraworx Relief Joint Discomfort and Inflamation',
  'Thermazene',
  'Thiamine',
  'THIAMINE HCl',
  'THIAMINE HYDROCHLORIDE',
  'Thiola',
  'Thiola EC',
  'Thioridazine Hydrochloride',
  'Thiotepa',
  'Thiothixene',
  'Thumb No Thumb Extra Strength',
  'Thymoglobulin',
  'THYQUIDITY',
  'Thyrogen',
  'Thyroid',
  'TIADYLT ER',
  'Tiagabine Hydrochloride',
  'TIAZAC',
  'Tibsovo',
  'ticagrelor',
  'TICE BCG',
  'Tigan',
  'TIGAN(R) (TRIMETHOBENZAMIDE HYDROCHLORIDE)',
  'Tigecycline',
  'Tiger Supply Inc APF',
  'TIGLUTIK',
  'Tikosyn',
  'Tilia Fe',
  'Timolol GFS',
  'Timolol Maleate',
  'Timolol Maleate Ophthalmic Gel Forming Solution, 0.25%',
  'Timolol Maleate Ophthalmic Gel Forming Solution, 0.5%',
  'Timoptic',
  'Timoptic in Ocudose',
  'Timoptic-XE',
  'Timothy, Standardized',
  'Timothy-Orchard Standardized Grass Pollen Mix',
  'Tindamax',
  'Tindazole',
  'Tinidazole',
  'Tiopronin',
  'Tirofiban hydrochloride',
  'Tirosint',
  'TISSUEBLUE',
  'TIS-U-SOL',
  'TIVDAK',
  'Tivicay',
  'Tivicay PD',
  'Tivorbex',
  'TIZANDINE',
  'Tizanidine',
  'Tizanidine HCL',
  'tizanidine hydrochloride',
  'Tizanidne hydrochloride',
  'TNKase',
  'TOBI',
  'TOBI Podhaler',
  'TobraDex',
  'Tobradex ST',
  'Tobramycin',
  'TOBRAMYCIN AND DEXAMETHASONE',
  'Tobramycin Inhalation',
  'Tobramycin Inhalation Solution',
  'Tobramycin Ophthalmic Solution',
  'Tobrex',
  'TOLAK',
  'TOLCAPONE',
  'Tolsura',
  'Tolterodine Tartarate',
  'Tolterodine Tartrate',
  'Tolterodine Tartrate Extended Release',
  'Tolvaptan',
  'Top Quality Mfg APF',
  'Topamax',
  'Topex',
  'Topex 60 Second Fluoride Foam',
  'Topex Neutral Fluoride Foam',
  'Topex Neutral pH Fluoride Gel',
  'Topicort',
  'Topiramate',
  'Toposar',
  'Topotecan',
  'topotecan hydrochloride',
  'TOPROL',
  'Toremifene Citrate',
  'Torisel',
  'Toronova II SUIK',
  'Toronova SUIK',
  'Torsemide',
  'T-O-S Standardized Grass Pollen Mix',
  'TOSYMRA',
  'TOTAL FEM BAL',
  'TOTAL TRI-ESTRO',
  'Totect',
  'TOUJEO',
  'TOUJEO Max',
  'Tovet (emollient formulation)',
  'Tovet Foam (Emollient Formulation)',
  'Toviaz',
  'Toxicology Medicated Collection System',
  'TOXYCOLOGY Medicated Collection System',
  'TPN Electrolytes',
  'TPOXX',
  'Trace Elements 4',
  'Tracleer',
  'Tradjenta',
  'Tralement',
  'TRAMADOL HCL',
  'Tramadol Hydrochloride',
  'TRAMADOL HYDROCHLORIDE AND ACETAMINOPHEN',
  'Trandolapril',
  'Trandolapril and Verapamil Hydrochloride',
  'Tranexamic Acid',
  'TRANEXAMIC ACID IN SODIUM CHLORIDE',
  'Transderm Scop',
  'Tranxene',
  'Tranylcypromine',
  'Tranylcypromine Sulfate',
  'Traumeel',
  'Traumeel Rx',
  'Travasol',
  'Travatan Z',
  'Travoprost',
  'Travoprost Ophthalmic',
  'Travoprost Ophthalmic Solution',
  'Travoprost Ophthalmic Solution USP, 0.004%',
  'Travoprost Ophthalmic Solution, 0.004%',
  'Trazimera',
  'Trazodone',
  'TRAZODONE HCL',
  'Trazodone Hydrochloride',
  'TREANDA',
  'Trecator',
  'Trelegy Ellipta',
  'Trelstar',
  'Tremfya',
  'Treprostinil',
  'Tresiba',
  'Tretinoin',
  'Tretinoin Cream',
  'Trexall',
  'Treximet',
  'Trezix',
  'Tri Femynor',
  'TriaDime-80',
  'Triamazole',
  'triamcinolone acetonide',
  'Triamterene',
  'Triamterene and Hydrochlorothiazide',
  'Trianex 0.05%',
  'Triazolam',
  'Tribenzor',
  'TRICARE PRENATAL',
  'triCitrasol',
  'TRICITRATES',
  'TRICON',
  'Tricor',
  'TRIDERM',
  'Tridesilon Cream',
  'TRIENTINE HYDROCHLORIDE',
  'TRIESENCE',
  'Tri-Estarylla',
  'Triferic',
  'Triferic AVNU',
  'Trifluoperazine Hydrochloride',
  'Trifluridine',
  'TriHeal-80',
  'Trihexyphenidyl Hydrochloride',
  'Trijardy XR',
  'Trikafta',
  'Tri-Legest Fe',
  'Trileptal',
  'Tri-Linyah',
  'Trilipix',
  'Tri-Lo- Estarylla',
  'Triloan II SUIK',
  'Triloan SUIK',
  'Trilociclo',
  'TRI-LO-MARZIA',
  'Tri-Lo-Mili',
  'Tri-Lo-Sprintec',
  'TRI-LUMA',
  'Trimethobenzamide',
  'Trimethobenzamide Hydrochloride',
  'Trimethoprim',
  'Trimethoprim sulfate and Polymyxin B sulfate',
  'Tri-Mili',
  'Trimipramine Maleate',
  'TRIMO SAN',
  'Trintellix',
  'Tri-Nymyo',
  'Triostat',
  'TRIPTODUR',
  'Trisenox',
  'Tri-Sprintec',
  'TriStart DHA',
  'TRITOCIN',
  'Triumeq',
  'Triumeq PD',
  'Tri-Vite Drops with Fluoride',
  'Trivix',
  'Trivix Lite',
  'Trivora',
  'Tri-VyLibra',
  'Tri-VyLibra Lo',
  'TRIZIVIR',
  'TRODELVY',
  'TROGARZO',
  'Trokendi XR',
  'TrophAmine',
  'Tropicamide',
  'Trospium Chloride',
  'TROSPIUM CHLORIDE ER',
  'Trudhesa',
  'Trulance',
  'Trulicity',
  'TRUSELTIQ',
  'TRUSOPT',
  'Truvada',
  'Truxima',
  'Tuberculinum',
  'TUBERSOL',
  'Tudorza Pressair',
  'TUKYSA',
  'Tulana',
  'Turalio',
  'Tuxarin',
  'TUZISTRA XR',
  'Twirla',
  'TWYNEO',
  'Tyblume',
  'Tybost',
  'Tydemy',
  'Tygacil',
  'TYKERB',
  'TYLENOL with Codeine',
  'Tymlos',
  'Tyrvaya',
  'TYSABRI',
  'TYVASO',
  'UBRELVY',
  'Uceris',
  'U-Cort',
  'UDENYCA',
  'UKONIQ',
  'ULORIC',
  'Ultane',
  'Ultiva',
  'Ultomiris',
  'ULTRACET',
  'ULTRAM',
  'Ultramicrosize Griseofulvin',
  'Ultrasal-ER',
  'Ultratag',
  'Ultra-Technekow',
  'Ultravate',
  'Ultravist',
  'Umecta Mousse',
  'UNASYN',
  'UNITHROID',
  'Unituxin',
  'UPLIZNA',
  'UPNEEQ',
  'UPTRAVI',
  'UPTRAVI Titration Pack',
  'UREA',
  'Urea 40 Percent',
  'Urea 41 Percent',
  'Urea 47% Cream',
  'Urea Cream 40%',
  'Urea Cream 41%',
  'UREA HYDRATING TOPICAL',
  'URELLE',
  'URIBEL',
  'Urimar-T',
  'Uro-458',
  'UROCIT-K',
  'UROGESIC BLUE',
  'Uro-MP',
  'Uroxatral',
  'Urso 250',
  'Urso Forte',
  'Ursodiol',
  'Ursodiol 200 mg',
  'Ursodiol 400 mg',
  'Ustell',
  'Utira-C',
  'UVADEX',
  'VABOMERE',
  'VABYSMO',
  'Vaccinotoxinum',
  'VagiBiom',
  'Vagifem',
  'Valacyclovir',
  'Valacyclovir Hydrochloride',
  'VALCHLOR',
  'Valcyte',
  'Valganciclovir',
  'Valganciclovir hydrochloride',
  'Valganciclovir hydrochloride for Oral',
  'Valium',
  'VallaDerm-90',
  'Valproate Sodium',
  'Valproic',
  'VALPROIC ACID',
  'Valrubicin Intravesical Solution',
  'Valsartan',
  'Valsartan and Hydrochlorothiazide',
  'VALSARTAN/HTCZ',
  'Valstar',
  'Valtoco',
  'VALTREX',
  'Vancocin',
  'Vancomycin',
  'VANCOMYCIN HYDROCHLORIDE',
  'Vandazole',
  'Vanilla SilQ',
  'Vanilla SilQ HD',
  'Vanilla SilQ MD',
  'VANIQA',
  'Vanos',
  'VANOXIDE',
  'VAPRISOL DEXTROSE IN PLASTIC CONTAINER',
  'Vardenafil',
  'Vardenafil Hydrochloride',
  'Varenicline',
  'Varibar Honey',
  'Varibar Nectar',
  'Varibar Pudding',
  'Varibar Thin Honey',
  'Varibar Thin Liquid',
  'Varithena',
  'VariZig',
  'Varophen',
  'Varubi',
  'Vascepa',
  'Vaseretic',
  'Vasopressin',
  'Vasostrict',
  'Vasotec',
  'Vazculep',
  'Vecamyl',
  'Vectibix',
  'Vectical',
  'Vecuronium Bromide',
  'Veklury',
  'VELCADE',
  'Veletri',
  'Velivet',
  'Velphoro',
  'VELTASSA',
  'VELTIN',
  'VEMLIDY',
  'Venclexta',
  'Venexa',
  'Venexa FE',
  'Venipuncture Px1',
  'Venlafaxine',
  'Venlafaxine HCL',
  'Venlafaxine Hydrochloride',
  'VennGel One',
  'Venofer',
  'VENOFER (IRON SUCROSE)',
  'VENTAVIS',
  'VENTOLIN',
  'VENTOLIN HFA',
  'Ventrixyl',
  'Ventrixyl Fe',
  'VERAPAMIL HCI',
  'VERAPAMIL HCL',
  'Verapamil Hydrochloride',
  'Verdeso',
  'Veregen',
  'VERELAN',
  'VERELAN PM',
  'Verkazia',
  'VERMOX',
  'VERQUVO',
  'VERSACLOZ',
  'Verzenio',
  'VESIcare',
  'Vestura',
  'Vet one',
  'VFEND',
  'Viadox',
  'Viagra',
  'VIBATIV',
  'Viberzi',
  'Vibramycin Calcium',
  'Vibramycin Hyclate',
  'Vibramycin Monohydrate',
  'Victoza',
  'VIDAZA',
  'Viekira Pak',
  'Vienva TM',
  'Vigabatrin',
  'vigabatrin for oral solution',
  'Vigabatrin for oral solution USP, 500 mg',
  'VIGADRONE',
  'VIGAMOX',
  'VIIBRYD',
  'VIJOICE',
  'Viltepso',
  'VIMIZIM',
  'Vimovo',
  'Vimpat',
  'Vinblastine Sulfate',
  'Vincasar PFS',
  'VinCRIStine Sulfate',
  'Vinorelbine',
  'Viokace',
  'VIORELE',
  'VIRACEPT',
  'Viramune',
  'Virazole',
  'Viread',
  'Visceral Polarity',
  'VISIONBLUE',
  'Visipaque',
  'Vistaril',
  'VISTOGARD',
  'Visudyne',
  'Vitafol',
  'Vitafol Fe Plus',
  'Vitafol OB',
  'Vitafol-OB Plus DHA',
  'Vital-D Rx',
  'Vitamin B Complex',
  'VITAMIN D',
  'Vitamin Deficiency Injectable System - B12',
  'Vitamin Deficiency System',
  'Vitamin K1',
  'VITAMIN K1 - PHYTONADIONE',
  'VITAMIN K1 PHYTONADIONE',
  'Vita-Rx Diabetic Vitamin',
  'VITRAKVI',
  'Vitramyn',
  'Vitranol',
  'Vitranol Fe',
  'VITRASE',
  'Vitrexate',
  'Vitrexate FE',
  'Vitrexyl',
  'Vitrexyl plus Iron',
  'Vivacaine',
  'Vivelle-Dot',
  'VIVITROL',
  'Vivlodex',
  'Vizamyl',
  'Vizimpro',
  'Vocabria',
  'Vogelxo',
  'Volnea',
  'Volumex',
  'Vonjo',
  'Voraxaze',
  'Voriconazole',
  'Vosevi',
  'VOTRIENT',
  'VOXZOGO 0.4mg',
  'VOXZOGO 0.56mg',
  'VOXZOGO 1.2mg',
  'VPRIV',
  'Vraylar',
  'Vtol LQ',
  'VUITY',
  'Vumerity',
  'VUSION',
  'Vyepti',
  'Vyfemla',
  'Vyleesi',
  'VyLibra',
  'Vyndamax',
  'Vyndaqel',
  'Vyondys 53',
  'Vytone',
  'VYTORIN',
  'Vyvanse',
  'VYVGART',
  'VYXEOS',
  'Vyzulta',
  'Wakix',
  'Warfarin Sodium',
  'Wasp Hymenoptera Venom',
  'Wasp Hymenoptera Venom Multidose',
  'Wasp Hymenoptera Venom Venomil Diagnostic',
  'Wasp Hymenoptera Venom Venomil Maintenance',
  'Wasp Venom Protein',
  'WEGOVY',
  'Welchol',
  'WELIREG',
  'WELLBUTRIN',
  'WellMind Vertigo',
  'Wentworth Alcohol Free',
  'Wera',
  'White Faced Hornet Hymenoptera Venom Multidose',
  'White Faced Hornet Hymenoptera Venom Venomil Diagnostic',
  'White Faced Hornet Hymenoptera Venom Venomil Maintenance',
  'White Faced Hornet Venom Protein',
  'WILZIN',
  'Winlevi',
  'WinRho SDF',
  'Wixela Inhub',
  'WYMZYA Fe',
  'Wynzora',
  'XACIATO',
  'Xadago',
  'Xalatan',
  'XALIX',
  'Xalkori',
  'Xanax',
  'XARACOLL',
  'Xarelto',
  'Xatmep',
  'Xcopri',
  'Xeglyze',
  'XELJANZ',
  'Xeloda',
  'XELPROS',
  'Xenical',
  'Xenleta',
  'Xenon',
  'Xenon, Xe-133',
  'Xeomin',
  'Xepi',
  'Xerava',
  'Xerese',
  'Xermelo',
  'XGEVA',
  'XHANCE',
  'XIAFLEX',
  'XIFAXAN',
  'XIGDUO',
  'Xiidra',
  'Ximino',
  'Xipere',
  'Xofigo',
  'Xofluza',
  'XOLAIR',
  'Xolair PFS',
  'Xolegel',
  'Xopenex',
  'Xopenex HFA',
  'Xospata',
  'XPOVIO',
  'Xrylix',
  'XTAMPZA',
  'Xtandi',
  'XULANE',
  'Xultophy 100/3.6',
  'XURIDEN',
  'Xylocaine',
  'XYLOCAINE(R) -MPF (LIDOCAINE HCI AND EPINEPHRINE)',
  'XYLOCAINE-MPF WITH EPI',
  'XYOSTED',
  'Xyrem',
  'XYWAV',
  'Yasmin',
  'Yaz',
  'Yellow Hornet Hymenoptera Venom Multidose',
  'Yellow Hornet Hymenoptera Venom Venomil Diagnostic',
  'Yellow Hornet Hymenoptera Venom Venomil Maintenance',
  'Yellow Hornet Venom Protein',
  'Yellow Jacket Hymenoptera Venom',
  'Yellow Jacket Hymenoptera Venom Multidose',
  'Yellow Jacket Hymenoptera Venom Venomil Diagnostic',
  'Yellow Jacket Hymenoptera Venom Venomil Maintenance',
  'Yellow Jacket Venom Protein',
  'YERVOY',
  'Yin-Yang Balance',
  'YONDELIS',
  'YONSA',
  'Yosprala',
  'YUPELRI',
  'YUTIQ',
  'Yuvafem',
  'ZAFEMY',
  'Zafirlukast',
  'ZALDYON',
  'Zaleplon',
  'ZALTRAP',
  'Zanaflex',
  'Zanosar',
  'Zap APF',
  'Zap Neutral',
  'Zarah',
  'Zarontin',
  'ZARXIO',
  'Zavesca',
  'ZCORT',
  'Zebutal',
  'Zeel',
  'Zegalogue',
  'ZEGERID',
  'ZEJULA',
  'ZELAPAR',
  'ZELBORAF',
  'ZEMBRACE SYMTOUCH',
  'Zemdri (plazomicin)',
  'Zemplar',
  'ZENATANE',
  'Zenpep',
  'Zenzedi',
  'ZEPATIER',
  'ZEPOSIA',
  'ZEPZELCA',
  'ZERBAXA',
  'Zerviate',
  'Zestoretic',
  'Zestril',
  'Zetia',
  'Zetonna',
  'Zevalin',
  'Ziac',
  'ZIAGEN',
  'ZIANA',
  'Ziclopro',
  'Zidovudine',
  'ZIEXTENZO',
  'Zilacaine Patch',
  'Zileuton',
  'ZiloVal 5%',
  'Zilretta',
  'ZILXI',
  'Zimhi',
  'ZINC',
  'Zinc Chloride',
  'Zinc Sulfate',
  'Zingo',
  'ZINPLAVA',
  'Zintrexyl-C',
  'ZIOPTAN',
  'Ziprasidone',
  'ziprasidone hydrochloride',
  'ziprasidone mesylate',
  'ZIPSOR',
  'Zirabev',
  'ZIRGAN',
  'Zithromax',
  'ZO Skin Health Pigment Control Creme Hydroquinone',
  'ZO Skin Health Pigment Control plus Blending Creme Hydroquinone',
  'ZO Skin Health Pigment Control plus Brightening Creme Hydroquinone plus Vitamin C',
  'ZO Skin Health Pigment Control Program Plus Hydroquinone',
  'ZOCOR',
  'ZOFRAN',
  'Zokinvy',
  'ZOLADEX',
  'Zoledronic Acid',
  'Zolgensma',
  'ZOLINZA',
  'zolmiptriptan',
  'Zolmitriptan',
  'Zolmitriptan OD',
  'Zoloft',
  'Zolpak',
  'Zolpidem',
  'Zolpidem Tartrate',
  'Zolpidem tartrate sublingual',
  'ZOLPIMIST',
  'ZOMACTON',
  'ZOMIG',
  'ZOMIG ZMT',
  'Zonalon',
  'Zonegran',
  'zonisamide',
  'ZONTIVITY',
  'ZOOBY',
  'Zorbtive',
  'Zorcaine',
  'Zortress',
  'Zorvolex',
  'Zosyn',
  'Zovia 1/35',
  'Zovirax',
  'Ztlido',
  'Zubsolv',
  'Zulresso',
  'Zumandimine',
  'ZUPLENZ',
  'Zyclara',
  'Zydelig',
  'ZYFLO',
  'ZYKADIA',
  'Zylet',
  'Zyloprim',
  'ZYMAXID',
  'ZYNLONTA',
  'ZYNRELEF',
  'ZYPITAMAG',
  'Zyprexa',
  'Zytiga',
  'Zyvana',
  'Zyvox'
];

export const relationsShip = {
  Mother: 'mother',
  Father: 'father',
  'Paternal Grandparent': 'paternal_grandmother',
  'Maternal Grandparent': 'maternal_grandmother',
  'Sister or Brother': 'sister_brother',
  'N/A': 'n/a'
};


export const constants = {
  /* General */
  other: -1,
  notSet: 0,

  /* booleans */
  yes: 1,
  true: 1,
  no: 2,
  false: 2,

  /* Surveys */
  surveys: {
    true: 'Yes',
    false: 'No'
  },

  /* Rating */
  rating: {
    notSet: -2,
    max: 10
  },

  /* BiologicalSex */
  male: 1,
  female: 2,

  /* Handeness */
  left: 1,
  right: 2,

  /* Ethinicity */
  hispanic: 1,
  nonHispanic: 2,

  /* Race */
  americanIndian: 1,
  asian: 2,
  africanAmerican: 3,
  pacificIslander: 4,
  white: 5,

  /* Education */
  highSchool: 16,
  someCollege: 18,
  incomplete2YearDegree: 25,
  oneYearCollege: 26,
  twoYearCollege: 27,
  threeYearCollege: 28,
  associatesDegree: 20,
  bachelorsDegree: 21,
  mastersDegree: 22,
  professionalDegree: 23,
  doctorateDegree: 24,

  /* Family Members */
  familyMembers: {
    mother: 'mother',
    father: 'father',
    maternalGrandMother: 'maternal grandmother',
    maternalGrandFather: 'maternal grandfather',
    paternalGrandMother: 'paternal grandmother',
    paternalGrandFather: 'paternal grandfather',
    sibling: 'sibling'
  },

  /* User levels */
  admin: 0,
  support: 1,
  patient: 2,

  /* Patient Types */
  daveVip: 0,
  vip: 1,
  partner: 2,
  superVip: 98,
  regular: 99,

  /* Application Types */
  webApp: 1,
  clinicServer: 2,
  adminTool: 3,
  researchTool: 4,

  /* Auth methods */
  application: 'Application',
  // authToken: 'Authorization Token',
  cookie: 'Session Cookie',

  /* Sources */
  sources: {
    webApp: 'webApp',
    suveyMonkey: 'SurveyMonkey'
  }
}

Object.freeze(module.exports)

